export const descriptions = [
    {code: 2, category: 1,
        label: { default: 'いて', 1: 'いて', 2: 'いて', 3: 'いて', 4: 'いて', 5: 'いて', 6: 'いて'},
        phrase: {
            default: 'いて座は、上半身が人間、下半身が馬の姿をしたケンタウルスが弓を射る姿をえがいた星座です。大神ゼウスの命令で、となりのさそり座が暴れ出さないように、さそり座の心臓にねらいをつけているのだといわれています。',
            1: 'いてざは、上はんしんが人げん、下はんしんが うまのすがたをしたケンタウルスが ゆみをいるすがたを えがいたせいざです。大かみゼウスのめいれいで、となりのさそりざが あばれ出さないように、さそりざのしんぞうに ねらいをつけているのだと いわれています。',
            2: 'いてざは、上半しんが人間、下半しんが馬のすがたをしたケンタウルスが弓をいるすがたをえがいた星ざです。大かみゼウスのめいれいで、となりのさそりざがあばれ出さないように、さそりざの心ぞうに ねらいをつけているのだといわれています。',
            3: 'いてざは、上半身が人間、下半身が馬のすがたをしたケンタウルスが弓をいるすがたをえがいた星ざです。大神ゼウスの命れいで、となりのさそりざがあばれ出さないように、さそりざの心ぞうにねらいをつけているのだといわれています。',
            4: 'いてざは、上半身が人間、下半身が馬のすがたをしたケンタウルスが弓をいるすがたをえがいた星ざです。大神ゼウスの命令で、となりのさそりざがあばれ出さないように、さそりざの心ぞうにねらいをつけているのだといわれています。',
            5: 'いてざは、上半身が人間、下半身が馬のすがたをしたケンタウルスが弓をいるすがたをえがいた星ざです。大神ゼウスの命令で、となりのさそりざが暴れ出さないように、さそりざの心ぞうにねらいをつけているのだといわれています。',
            6: 'いて座は、上半身が人間、下半身が馬の姿をしたケンタウルスが弓を射る姿をえがいた星座です。大神ゼウスの命令で、となりのさそり座が暴れ出さないように、さそり座の心臓にねらいをつけているのだといわれています。',
        }
    },
    {code: 3, category: 1,
        label: { default: 'いるか', 1: 'いるか', 2: 'いるか', 3: 'いるか', 4: 'いるか', 5: 'いるか', 6: 'いるか'},
        phrase: {
            default: 'ギリシア神話では、イルカは海の神ポセイドンの使いとされていてます。音楽家オリオンを助けたイルカがこの星座のモデルだといわれています。',
            1: 'ギリシアしんわでは、イルカうみのかみポセイドン のつかいとされていてます。おんがくかオリオンを たすけたイルカが このせいざのモデルだといわれています。',
            2: 'ギリシアしん話では、イルカは海のかみポセイドンのつかいとされていてます。音楽家（おんがくか）オリオンをたすけたイルカが この星ざのモデルだといわれています。',
            3: 'ギリシア神話では、イルカは海の神ポセイドンの使いとされていてます。音楽家オリオンを助けたイルカがこの星ざのモデルだといわれています。',
            4: 'ギリシア神話では、イルカは海の神ポセイドンの使いとされていてます。音楽家オリオンを助けたイルカがこの星ざのモデルだといわれています。',
            5: 'ギリシア神話では、イルカは海の神ポセイドンの使いとされていてます。音楽家オリオンを助けたイルカがこの星ざのモデルだといわれています。',
            6: 'ギリシア神話では、イルカは海の神ポセイドンの使いとされていてます。音楽家オリオンを助けたイルカがこの星座のモデルだといわれています。',
        }
    },
    {code: 4, category: 1,
        label: { default: 'うお', 1: 'うお', 2: 'うお', 3: 'うお', 4: 'うお', 5: 'うお', 6: 'うお'},
        phrase: {
            default: 'うお座は二匹の魚のしっぽをひもで結んだ様子を表しています。魚とひもはチグリス川とユーフラテス川を表現しているといわれています。美の女神アフロディーテとその子供エロスが、怪物デュポンが現れたときに、魚になってお互いにはぐれないようにひもで結んで逃げたという神話があります。',
            1: 'うおざは二ひきのさかなのしっぽをひもでむすんだようすをあらわしています。さかなとひもはチグリス川とユーフラテス川をひょうげんしているといわれています。びのめがみアフロディーテとそのこどもエロスが、かいぶつデュポンがあらわれたときに、さかなになっておたがいにはぐれないようにひもでむすんでにげたというしんわがあります。',
            2: 'うおざは二ひきの魚のしっぽをひもでむすんだようすをあらわしています。魚とひもはチグリス川とユーフラテス川をひょうげんしているといわれています。びのめがみアフロディーテとその子どもエロスが、かいぶつデュポンがあらわれたときに、魚になっておたがいにはぐれないようにひもでむすんでにげたというしん話があります。',
            3: 'うおざは二ひきの魚のしっぽをひもでむすんだ様子を表しています。魚とひもはチグリス川とユーフラテス川を表げんしているといわれています。美の女神アフロディーテとその子どもエロスが、怪物（かいぶつ）デュポンがあらわれたときに、魚になっておたがいにはぐれないようにひもでむすんでにげたという神話があります。',
            4: 'うおざは二ひきの魚のしっぽをひもで結んだ様子を表しています。魚とひもはチグリス川とユーフラテス川を表げんしているといわれています。美の女神アフロディーテとその子どもエロスが、怪物（かいぶつ）デュポンが現れたときに、魚になっておたがいにはぐれないようにひもで結んでにげたという神話があります。',
            5: 'うおざは二ひきの魚のしっぽをひもで結んだ様子を表しています。魚とひもはチグリス川とユーフラテス川を表現しているといわれています。美の女神アフロディーテとその子どもエロスが、怪物（かいぶつ）デュポンが現れたときに、魚になっておたがいにはぐれないようにひもで結んでにげたという神話があります。',
            6: 'うお座は二ひきの魚のしっぽをひもで結んだ様子を表しています。魚とひもはチグリス川とユーフラテス川を表現しているといわれています。美の女神アフロディーテとその子供エロスが、怪物（かいぶつ）デュポンが現れたときに、魚になっておたがいにはぐれないようにひもで結んでにげたという神話があります。',
        }
    },
    {code: 5, category: 1,
        label: { default: 'うさぎ', 1: 'うさぎ', 2: 'うさぎ', 3: 'うさぎ', 4: 'うさぎ', 5: 'うさぎ', 6: 'うさぎ'},
        phrase: {
            default: 'オリオン座の南にあるうさぎ座は、狩人オリオンの足元を逃げ回り、猟犬（おおいぬ座・こいぬ座）に追われるうさぎを表しています。ギリシア神話では、オリオンにふみつぶされてしまったうさぎを神があわれみ星座にしたといわれています。',
            1: 'オリオンざのみなみにある うさぎざは、狩人（かりうど）オリオンの足もとをにげまわり、りょう犬（おおいぬざ・こいぬざ）におわれる うさぎをあらわしています。ギリシアしんわでは、オリオンに ふみつぶされてしまったうさぎを　かみがあわれみ せいざにしたといわれています。',
            2: 'オリオンざの南にあるうさぎざは、狩人（かりうど）オリオンの足元をにげ回り、りょう犬（おおいぬざ・こいぬざ）におわれる うさぎをあらわしています。ギリシアしん話では、オリオンにふみつぶされてしまったうさぎを かみがあわれみ星ざにしたといわれています。',
            3: 'オリオンざの南にあるうさぎざは、狩人（かりうど）オリオンの足元をにげ回り、りょう犬（おおいぬざ・こいぬざ）に追われるうさぎを表しています。ギリシア神話では、オリオンにふみつぶされてしまったうさぎを神があわれみ星ざにしたといわれています。',
            4: 'オリオンざの南にあるうさぎざは、狩人（かりうど）オリオンの足元をにげ回り、りょう犬（おおいぬざ・こいぬざ）に追われるうさぎを表しています。ギリシア神話では、オリオンにふみつぶされてしまったうさぎを神があわれみ星ざにしたといわれています。',
            5: 'オリオンざの南にあるうさぎざは、狩人（かりうど）オリオンの足元をにげ回り、りょう犬（おおいぬざ・こいぬざ）に追われるうさぎを表しています。ギリシア神話では、オリオンにふみつぶされてしまったうさぎを神があわれみ星ざにしたといわれています。',
            6: 'オリオン座の南にあるうさぎ座は、狩人（かりうど）オリオンの足元をにげ回り、りょう犬（おおいぬ座・こいぬ座）に追われるうさぎを表しています。ギリシア神話では、オリオンにふみつぶされてしまったうさぎを神があわれみ星座にしたといわれています。',
        }
    },
    {code: 6, category: 1,
        label: { default: 'うしかい', 1: 'うしかい', 2: 'うしかい', 3: 'うしかい', 4: 'うしかい', 5: 'うしかい', 6: 'うしかい'},
        phrase: {
            default: 'うしかい座は2匹の犬（りょうけん座）をつれてクマ（おおぐま座）を追う男の姿がえがかれています。ギリシア神話では、おおぐま座のクマに変身したカリストの息子アルカス、または天をかつぐ巨人アトラスがモデルだといわれています。',
            1: 'うしかいざは2ひきの犬（りょうけんざ）をつれてクマ（おおぐまざ）をおう　男のすがたが えがかれています。ギリシアしんわでは、おおぐまざのクマにへんしんした カリストのむす子アルカス、または天をかつぐ きょ人アトラスがモデルだといわれています。',
            2: 'うしかいざは2ひきの犬（りょうけんざ）をつれてクマ（おおぐまざ）をおう男のすがたが えがかれています。ギリシアしん話では、おおぐまざのクマにへんしんした カリストのむす子アルカス、または天をかつぐ きょ人アトラスがモデルだといわれています。',
            3: 'うしかいざは2ひきの犬（りょうけんざ）をつれてクマ（おおぐまざ）を追う男のすがたが えがかれています。ギリシア神話では、おおぐまざのクマにへん身したカリストの息子アルカス、または天をかつぐ きょ人アトラスがモデルだといわれています。',
            4: 'うしかいざは2ひきの犬（りょうけんざ）をつれてクマ（おおぐまざ）を追う男のすがたが えがかれています。ギリシア神話では、おおぐまざのクマに変身したカリストの息子アルカス、または天をかつぐ きょ人アトラスがモデルだといわれています。',
            5: 'うしかいざは2ひきの犬（りょうけんざ）をつれてクマ（おおぐまざ）を追う男のすがたが えがかれています。ギリシア神話では、おおぐまざのクマに変身したカリストの息子アルカス、または天をかつぐ きょ人アトラスがモデルだといわれています。',
            6: 'うしかい座は2ひきの犬（りょうけん座）をつれてクマ（おおぐま座）を追う男の姿がえがかれています。ギリシア神話では、おおぐま座のクマに変身したカリストの息子アルカス、または天をかつぐきょ人アトラスがモデルだといわれています。',
        }
    },
    {code: 7, category: 1,
        label: { default: 'うみへび', 1: 'うみへび', 2: 'うみへび', 3: 'うみへび', 4: 'うみへび', 5: 'うみへび', 6: 'うみへび'},
        phrase: {
            default: 'うみへび座は、ギリシア神話に登場する九つの頭を持つヒドラという水蛇の怪物で英雄ヘルクレスに退治されました。88星座の中で一番大きな星座です。',
            1: 'うみへびざは、ギリシアしんわにとうじょうする 九つのあたまをもつ ヒドラという水へびのかいぶつで えいゆうヘルクレスにたいじされました。88せいざの中で一ばん大きなせいざです。',
            2: 'うみへびざは、ギリシアしん話にとう場する九つの頭をもつヒドラという水へびのかいぶつで えいゆうヘルクレスにたいじされました。88星ざの中で一番大きな星ざです。',
            3: 'うみへびざは、ギリシア神話に登場する九つの頭を持つヒドラという水へびの怪物（かいぶつ）でえいゆうヘルクレスにたいじされました。88星ざの中で一番大きな星ざです。',
            4: 'うみへびざは、ギリシア神話に登場する九つの頭を持つヒドラという水へびの怪物（かいぶつ）で英ゆうヘルクレスに退治（たいじ）されました。88星ざの中で一番大きな星ざです。',
            5: 'うみへびざは、ギリシア神話に登場する九つの頭を持つヒドラという水へびの怪物（かいぶつ）で英ゆうヘルクレスに退治されました。88星ざの中で一番大きな星ざです。',
            6: 'うみへび座は、ギリシア神話に登場する九つの頭を持つヒドラという水へびの怪物（かいぶつ）で英ゆうヘルクレスに退治されました。88星座の中で一番大きな星座です。',
        }
    },
    {code: 8, category: 1,
        label: { default: 'エリダヌス', 1: 'エリダヌス', 2: 'エリダヌス', 3: 'エリダヌス', 4: 'エリダヌス', 5: 'エリダヌス', 6: 'エリダヌス'},
        phrase: {
            default: 'エリダヌス座は、ギリシア神話で登場するエリダヌス川が由来といわれています。みずがめ座の水瓶から流れ出た水がエリダヌス川（エリダヌス座）となっています。',
            1: 'エリダヌスざは、ギリシアしんわでとうじょうする エリダヌス川がゆらいといわれています。みずがめざのみずがめから ながれ出た水が エリダヌス川（エリダヌスざ）となっています。',
            2: 'エリダヌスざは、ギリシアしん話でとう場するエリダヌス川が由来（ゆらい）といわれています。みずがめざのみずがめから ながれ出た水がエリダヌス川（エリダヌスざ）となっています。',
            3: 'エリダヌスざは、ギリシア神話で登場するエリダヌス川が由来といわれています。みずがめざのみずがめから流れ出た水がエリダヌス川（エリダヌスざ）となっています。',
            4: 'エリダヌスざは、ギリシア神話で登場するエリダヌス川が由来といわれています。みずがめざの水がめから流れ出た水がエリダヌス川（エリダヌスざ）となっています。',
            5: 'エリダヌスざは、ギリシア神話で登場するエリダヌス川が由来といわれています。みずがめざの水がめから流れ出た水がエリダヌス川（エリダヌスざ）となっています。',
            6: 'エリダヌス座は、ギリシア神話で登場するエリダヌス川が由来といわれています。みずがめ座の水がめから流れ出た水がエリダヌス川（エリダヌス座）となっています。',
        }
    },
    {code: 9, category: 1,
        label: { default: 'おうし', 1: 'おうし', 2: 'おうし', 3: 'おうし', 4: 'おうし', 5: 'おうし', 6: 'おうし'},
        phrase: {
            default: 'おうし座は、王女エウロパに恋した大神ゼウスが彼女を連れ帰るために白い牛に変身した姿とされています。',
            1: 'おうしざは、王女エウロパに こいした大かみゼウスが かの女をつれかえるために 白いうしにへんしんした すがたとされています。',
            2: 'おうしざは、王女エウロパに こいした大かみゼウスが かの女をつれ帰るために白い牛にへんしんしたすがたとされています。',
            3: 'おうしざは、王女エウロパに こいした大神ゼウスが かの女をつれ帰るために白い牛にへん身したすがたとされています。',
            4: 'おうしざは、王女エウロパに こいした大神ゼウスが かの女を連れ帰るために白い牛に変身したすがたとされています。',
            5: 'おうしざは、王女エウロパに こいした大神ゼウスが かの女を連れ帰るために白い牛に変身したすがたとされています。',
            6: 'おうし座は、王女エウロパに こいした大神ゼウスが かの女を連れ帰るために白い牛に変身した姿とされています。',
        }
    },
    {code: 10, category: 1,
        label: { default: 'おおいぬ', 1: 'おおいぬ', 2: 'おおいぬ', 3: 'おおいぬ', 4: 'おおいぬ', 5: 'おおいぬ', 6: 'おおいぬ'},
        phrase: {
            default: 'おおいぬ座は、オリオンの足元でうさぎを追いかける猟犬といわれています。その他にも、月の女神アルテミスの侍女の飼っていた名犬レラプスという説もあります。',
            1: 'おおいぬざは、オリオンの足もとで うさぎをおいかける りょう犬といわれています。そのほかにも、月のめがみアルテミスの侍女（じじょ）のかっていた名犬レラプスというせつもあります。',
            2: 'おおいぬざは、オリオンの足元でうさぎをおいかけるりょう犬といわれています。そのほかにも、月のめがみアルテミスの侍女（じじょ）のかっていた名犬レラプスというせつもあります。',
            3: 'おおいぬざは、オリオンの足元でうさぎを追いかけるりょう犬といわれています。その他にも、月の女神アルテミスの侍女（じじょ）のかっていた名犬レラプスというせつもあります。',
            4: 'おおいぬざは、オリオンの足元でうさぎを追いかけるりょう犬といわれています。その他にも、月の女神アルテミスの侍女（じじょ）のかっていた名犬レラプスという説もあります。',
            5: 'おおいぬざは、オリオンの足元でうさぎを追いかけるりょう犬といわれています。その他にも、月の女神アルテミスの侍女（じじょ）の飼っていた名犬レラプスという説もあります。',
            6: 'おおいぬ座は、オリオンの足元でうさぎを追いかけるりょう犬といわれています。その他にも、月の女神アルテミスの侍女（じじょ）の飼っていた名犬レラプスという説もあります。',
        }
    },
    {code: 11, category: 1,
        label: { default: 'おおかみ', 1: 'おおかみ', 2: 'おおかみ', 3: 'おおかみ', 4: 'おおかみ', 5: 'おおかみ', 6: 'おおかみ'},
        phrase: {
            default: 'ギリシア神話では、アルカディアの王リュカオンが 大神ゼウスに牛肉と偽って人間の肉を食べさせたため、怒ったゼウスが彼をおおかみの姿に変えたといわれています。',
            1: 'ギリシアしんわでは、アルカディアの王リュカオンが大かみゼウスに ぎゅうにくといつわって 人げんのにくをたべさせたため、おこったゼウスが かれをおおかみのすがたにかえた といわれています。',
            2: 'ギリシアしん話では、アルカディアの王リュカオンが大かみゼウスに牛肉といつわって人間の肉を食べさせたため、おこったゼウスが かれをおおかみのすがたにかえた といわれています。',
            3: 'ギリシア神話では、アルカディアの王リュカオンが大神ゼウスに牛肉といつわって人間の肉を食べさせたため、おこったゼウスが かれをおおかみのすがたにかえた といわれています。',
            4: 'ギリシア神話では、アルカディアの王リュカオンが大神ゼウスに牛肉といつわって人間の肉を食べさせたため、おこったゼウスが かれをおおかみのすがたに変えた といわれています。',
            5: 'ギリシア神話では、アルカディアの王リュカオンが大神ゼウスに牛肉といつわって人間の肉を食べさせたため、おこったゼウスが かれをおおかみのすがたに変えた といわれています。',
            6: 'ギリシア神話では、アルカディアの王リュカオンが大神ゼウスに牛肉といつわって人間の肉を食べさせたため、おこったゼウスが かれをおおかみの姿に変えた といわれています。',
        }
    },
    {code: 12, category: 1,
        label: { default: 'おおぐま', 1: 'おおぐま', 2: 'おおぐま', 3: 'おおぐま', 4: 'おおぐま', 5: 'おおぐま', 6: 'おおぐま'},
        phrase: {
            default: 'おおぐま座は、女神の怒りをかったカリストが熊の姿に変えられ、それを知らない息子のアルカスに殺されそうになったとき、大神ゼウスが急いで2人を空に舞い上げ、アルカスも熊の姿に変えて星にしたという神話があります。熊のしっぽが長いのは、ゼウスが空にあげるときに慌ててしっぽをつかんで投げたために伸びてしまった、という話もあります。',
            1: 'おおぐまざは、めがみのいかりをかったカリストが くまのすがたにかえられ、それをしらないむす子のアルカスに ころされそうになったとき、大かみゼウスがいそいで2人を空にまい上げ、アルカスもくまのすがたにかえてほしにした というしんわがあります。くまのしっぽがながいのは、ゼウスが空にあげるときに あわててしっぽをつかんでなげたためにのびてしまった、というはなしもあります。',
            2: 'おおぐまざは、めがみのいかりをかったカリストが くまのすがたにかえられ、それを知らないむす子のアルカスに ころされそうになったとき、大かみゼウスがいそいで 2人を空にまい上げ、アルカスもくまのすがたにかえて星にした というしん話があります。くまのしっぽが長いのは、ゼウスが空にあげるときに あわててしっぽをつかんでなげたためにのびてしまった、という話もあります。',
            3: 'おおぐまざは、女神のいかりをかったカリストが くまのすがたにかえられ、それを知らない息子のアルカスに ころされそうになったとき、大神ゼウスが急いで2人を空にまい上げ、アルカスもくまのすがたにかえて星にしたという神話があります。くまのしっぽが長いのは、ゼウスが空にあげるときに あわててしっぽをつかんで投げたためにのびてしまった、という話もあります。',
            4: 'おおぐまざは、女神のいかりをかったカリストが くまのすがたに変えられ、それを知らない息子のアルカスに殺されそうになったとき、大神ゼウスが急いで2人を空にまい上げ、アルカスもくまのすがたに変えて星にしたという神話があります。くまのしっぽが長いのは、ゼウスが空にあげるときに あわててしっぽをつかんで投げたためにのびてしまった、という話もあります。',
            5: 'おおぐまざは、女神のいかりをかったカリストが くまのすがたに変えられ、それを知らない息子のアルカスに殺されそうになったとき、大神ゼウスが急いで2人を空にまい上げ、アルカスもくまのすがたに変えて星にしたという神話があります。くまのしっぽが長いのは、ゼウスが空にあげるときに あわててしっぽをつかんで投げたためにのびてしまった、という話もあります。',
            6: 'おおぐま座は、女神のいかりをかったカリストがくまの姿に変えられ、それを知らない息子のアルカスに殺されそうになったとき、大神ゼウスが急いで2人を空にまい上げ、アルカスもくまの姿に変えて星にしたという神話があります。くまのしっぽが長いのは、ゼウスが空にあげるときに あわててしっぽをつかんで投げたためにのびてしまった、という話もあります。',
        }
    },
    {code: 13, category: 1,
        label: { default: 'おとめ', 1: 'おとめ', 2: 'おとめ', 3: 'おとめ', 4: 'おとめ', 5: 'おとめ', 6: 'おとめ'},
        phrase: {
            default: 'おとめ座のモデルは、さまざまな女神の姿とされています。おとめ座の隣にてんびん座があるため正義の女神アストライアが正義を計るためのてんびんを持っている姿といわれています。また、左手には麦の穂先を持ち、羽の生えた農業の女神デメテルという説もあります。',
            1: 'おとめざのモデルは、さまざまなめがみのすがたとされています。おとめざのとなりにてんびんざがあるため 正ぎのめがみアストライアが 正ぎをはかるためのてんびんをもっているすがた といわれています。また、左手にはむぎのほ先をもち、はねの生えた のうぎょうのめがみデメテル というせつもあります。',
            2: 'おとめざのモデルは、さまざまなめがみのすがたとされています。おとめざのとなりにてんびんざがあるため 正ぎのめがみアストライアが 正ぎを計るためのてんびんをもっているすがた といわれています。また、左手には麦のほ先をもち、羽の生えた のうぎょうのめがみデメテル というせつもあります。',
            3: 'おとめざのモデルは、さまざまな女神のすがたとされています。おとめざのとなりにてんびんざがあるため 正ぎの女神アストライアが 正ぎを計るためのてんびんを持っているすがた といわれています。また、左手には麦のほ先を持ち、羽の生えた農業の女神デメテルというせつもあります。',
            4: 'おとめざのモデルは、さまざまな女神のすがたとされています。おとめざのとなりにてんびんざがあるため 正ぎの女神アストライアが 正ぎを計るためのてんびんを持っているすがた といわれています。また、左手には麦のほ先を持ち、羽の生えた農業の女神デメテルという説もあります。',
            5: 'おとめざのモデルは、さまざまな女神のすがたとされています。おとめざのとなりにてんびんざがあるため 正義の女神アストライアが 正義を計るためのてんびんを持っているすがた といわれています。また、左手には麦のほ先を持ち、羽の生えた農業の女神デメテルという説もあります。',
            6: 'おとめ座のモデルは、さまざまな女神の姿とされています。おとめ座のとなりにてんびん座があるため正義の女神アストライアが正義を計るためのてんびんを持っている姿といわれています。また、左手には麦のほ先を持ち、羽の生えた農業の女神デメテルという説もあります。',
        }
    },
    {code: 14, category: 1,
        label: { default: 'おひつじ', 1: 'おひつじ', 2: 'おひつじ', 3: 'おひつじ', 4: 'おひつじ', 5: 'おひつじ', 6: 'おひつじ'},
        phrase: {
            default: 'おひつじ座は、ギリシア神話でいけにえにされそうになったふたごを助けた金色の毛をした空飛ぶ羊の話が由来といわれています。',
            1: 'おひつじざは、ギリシアしんわで いけにえにされそうになったふたごをたすけた 金いろのけをした 空とぶひつじのはなしがゆらいといわれています。',
            2: 'おひつじざは、ギリシアしん話でいけにえにされそうになったふたごをたすけた 金色の毛をした 空とぶひつじの話が由来（ゆらい）といわれています。',
            3: 'おひつじざは、ギリシア神話でいけにえにされそうになったふたごを助けた金色の毛をした空とぶ羊の話が由来といわれています。',
            4: 'おひつじざは、ギリシア神話でいけにえにされそうになったふたごを助けた金色の毛をした空飛ぶ羊の話が由来といわれています。',
            5: 'おひつじざは、ギリシア神話でいけにえにされそうになったふたごを助けた金色の毛をした空飛ぶ羊の話が由来といわれています。',
            6: 'おひつじ座は、ギリシア神話でいけにえにされそうになったふたごを助けた金色の毛をした空飛ぶ羊の話が由来といわれています。',
        }
    },
    {code: 15, category: 1,
        label: { default: 'オリオン', 1: 'オリオン', 2: 'オリオン', 3: 'オリオン', 4: 'オリオン', 5: 'オリオン', 6: 'オリオン'},
        phrase: {
            default: 'いばっていたオリオンをこらしめるために、大神ゼウスの妻の女神ヘラが猛毒をもつ大さそりを送り、さされて命を落としてしまったという神話があります。さそり座が昇って来ると、オリオン座は西の地平に沈んでしまい、2つの星座が空に並ぶことがない位置関係から、オリオンがさそりを恐れて逃げている様子が目に浮かびます。',
            1: 'いばっていたオリオンをこらしめるために、大かみゼウスのつまのめがみヘラが もうどくをもつ大さそりをおくり、さされていのちをおとしてしまった というしんわがあります。さそりざがのぼってくると、オリオンざは にしのちへいにしずんでしまい、2つのせいざが空にならぶことがない いちかんけいから、オリオンがさそりをおそれて にげているようすが目にうかびます。',
            2: 'いばっていたオリオンをこらしめるために、大かみゼウスのつまのめがみヘラが もうどくをもつ大さそりをおくり、さされていのちをおとしてしまった というしん話があります。さそりざがのぼって来ると、オリオンざは西の地へいにしずんでしまい、2つの星ざが空にならぶことがない いちかんけいから、オリオンがさそりをおそれて にげているようすが目にうかびます。',
            3: 'いばっていたオリオンをこらしめるために、大神ゼウスのつまの女神ヘラが もうどくをもつ大さそりを送り、さされて命を落としてしまった という神話があります。さそりざがのぼって来ると、オリオンざは西の地平にしずんでしまい、2つの星ざが空にならぶことがない いちかん係から、オリオンがさそりをおそれて にげている様子が目にうかびます。',
            4: 'いばっていたオリオンをこらしめるために、大神ゼウスのつまの女神ヘラが もう毒をもつ大さそりを送り、さされて命を落としてしまった という神話があります。さそりざがのぼって来ると、オリオンざは西の地平にしずんでしまい、2つの星ざが空にならぶことがない位置関係から、オリオンがさそりをおそれてにげている様子が目にうかびます。',
            5: 'いばっていたオリオンをこらしめるために、大神ゼウスの妻の女神ヘラが もう毒をもつ大さそりを送り、さされて命を落としてしまった という神話があります。さそりざがのぼって来ると、オリオンざは西の地平にしずんでしまい、2つの星ざが空にならぶことがない位置関係から、オリオンがさそりをおそれてにげている様子が目にうかびます。',
            6: 'いばっていたオリオンをこらしめるために、大神ゼウスの妻の女神ヘラが もう毒をもつ大さそりを送り、さされて命を落としてしまった という神話があります。さそり座がのぼって来ると、オリオン座は西の地平にしずんでしまい、2つの星座が空に並ぶことがない位置関係から、オリオンがさそりをおそれてにげている様子が目にうかびます。',
        }
    },
    {code: 16, category: 1,
        label: { default: 'カシオペヤ', 1: 'カシオペヤ', 2: 'カシオペヤ', 3: 'カシオペヤ', 4: 'カシオペヤ', 5: 'カシオペヤ', 6: 'カシオペヤ'},
        phrase: {
            default: 'カシオペヤ座はギリシア神話に登場するエチオピアの王妃カッシオペイアに由来しています。 自慢好きのカシオペヤが、娘のアンドロメダと海の妖精の美しさを比べたことから、海の神ポセイドンが怒り、エチオピアに大災害をもたらします。',
            1: 'カシオペヤざは ギリシアしんわにとうじょうする エチオピアの王ひカッシオペイアにゆらいしています。じまんすきのカシオペヤが、むすめのアンドロメダとうみのようせいの うつくしさをくらべたことから、うみのかみポセイドンがいかり、エチオピアに大さいがいをもたらします。',
            2: 'カシオペヤざはギリシアしん話にとう場するエチオピアの王ひカッシオペイアに由来（ゆらい）しています。自まんすきのカシオペヤが、むすめのアンドロメダと海のようせいの うつくしさをくらべたことから、海のかみポセイドンがいかり、エチオピアに大さいがいをもたらします。',
            3: 'カシオペヤざはギリシア神話に登場するエチオピアの王ひカッシオペイアに由来しています。自まんすきのカシオペヤが、むすめのアンドロメダと海のようせいの美しさをくらべたことから、海の神ポセイドンがいかり、エチオピアに大さいがいをもたらします。',
            4: 'カシオペヤざはギリシア神話に登場するエチオピアの王ひカッシオペイアに由来しています。自まん好きのカシオペヤが、むすめのアンドロメダと海のようせいの美しさをくらべたことから、海の神ポセイドンがいかり、エチオピアに大災害（だいさいがい）をもたらします。',
            5: 'カシオペヤざはギリシア神話に登場するエチオピアの王ひカッシオペイアに由来しています。自まん好きのカシオペヤが、むすめのアンドロメダと海のよう精の美しさを比べたことから、海の神ポセイドンがいかり、エチオピアに大災害をもたらします。',
            6: 'カシオペヤ座はギリシア神話に登場するエチオピアの王ひカッシオペイアに由来しています。自まん好きのカシオペヤが、むすめのアンドロメダと海のよう精の美しさを比べたことから、海の神ポセイドンがいかり、エチオピアに大災害をもたらします。',
        }
    },
    {code: 17, category: 1,
        label: { default: 'かに', 1: 'かに', 2: 'かに', 3: 'かに', 4: 'かに', 5: 'かに', 6: 'かに'},
        phrase: {
            default: 'かに座は、ギリシア神話で英雄ヘルクレスが怪物ヒドラ（うみへび座）と戦ったときにヘルクレスにふみつぶされてしまったかにが星になったといわれています。',
            1: 'かにざは、ギリシアしんわでえいゆうヘルクレスが かいぶつヒドラ（うみへびざ）とたたかったときに ヘルクレスにふみつぶされてしまった かにが ほしになったといわれています。',
            2: 'かにざは、ギリシアしん話でえいゆうヘルクレスが かいぶつヒドラ（うみへびざ）とたたかったときに ヘルクレスにふみつぶされてしまった かにが星になったといわれています。',
            3: 'かにざは、ギリシア神話でえいゆうヘルクレスが怪物（かいぶつ）ヒドラ（うみへびざ）とたたかったときに ヘルクレスにふみつぶされてしまった かにが星になったといわれています。',
            4: 'かにざは、ギリシア神話で英ゆうヘルクレスが怪物（かいぶつ）ヒドラ（うみへびざ）と戦ったときにヘルクレスにふみつぶされてしまったかにが星になったといわれています。',
            5: 'かにざは、ギリシア神話で英ゆうヘルクレスが怪物（かいぶつ）ヒドラ（うみへびざ）と戦ったときにヘルクレスにふみつぶされてしまったかにが星になったといわれています。',
            6: 'かに座は、ギリシア神話で英ゆうヘルクレスが怪物（かいぶつ）ヒドラ（うみへび座）と戦ったときにヘルクレスにふみつぶされてしまったかにが星になったといわれています。',
        }
    },
    {code: 18, category: 1,
        label: { default: 'からす', 1: 'からす', 2: 'からす', 3: 'からす', 4: 'からす', 5: 'からす', 6: 'からす'},
        phrase: {
            default: 'からす座のモデルは、ギリシア神話に出てくる太陽の神アポロンに仕えていたカラスです。アポロンにうそをついたために罰として、真っ黒な姿にかえられ言葉をうばわれてしまいました。',
            1: 'からすざのモデルは、ギリシアしんわに出てくる たいようのかみアポロンに つかえていたカラスです。アポロンにうそをついたためにばつとして、まっくろなすがたにかえられ ことばをうばわれてしまいました。',
            2: 'からすざのモデルは、ギリシアしん話に出てくる太陽（たいよう）のかみアポロンに つかえていたカラスです。アポロンにうそをついたためにばつとして、まっ黒なすがたにかえられ言ばをうばわれてしまいました。',
            3: 'からすざのモデルは、ギリシア神話に出てくる太陽の神アポロンに仕えていたカラスです。アポロンにうそをついたためにばつとして、真っ黒なすがたにかえられ言葉をうばわれてしまいました。',
            4: 'からすざのモデルは、ギリシア神話に出てくる太陽の神アポロンに仕えていたカラスです。アポロンにうそをついたためにばつとして、真っ黒なすがたにかえられ言葉をうばわれてしまいました。',
            5: 'からすざのモデルは、ギリシア神話に出てくる太陽の神アポロンに仕えていたカラスです。アポロンにうそをついたためにばつとして、真っ黒なすがたにかえられ言葉をうばわれてしまいました。',
            6: 'からす座のモデルは、ギリシア神話に出てくる太陽の神アポロンに仕えていたカラスです。アポロンにうそをついたためにばつとして、真っ黒な姿にかえられ言葉をうばわれてしまいました。',
        }
    },
    {code: 19, category: 1,
        label: { default: 'かんむり', 1: 'かんむり', 2: 'かんむり', 3: 'かんむり', 4: 'かんむり', 5: 'かんむり', 6: 'かんむり'},
        phrase: {
            default: 'かんむり座は冠を描いた小さな半円形の星座です。ギリシア神話では、酒神ディオニソスがクレタ島の王女アリアドネに贈った美しい宝冠とされています。',
            1: 'かんむりざは かんむりをえがいた小さなはん円けいのせいざです。ギリシアしんわでは、しゅしんディオニソスが クレタとうの王女アリアドネにおくった うつくしい宝冠（ほうかん）とされています。',
            2: 'かんむりざはかんむりをえがいた小さな半円形の星ざです。ギリシアしん話では、さけかみディオニソスが クレタしまの王女アリアドネにおくった うつくしい宝冠（ほうかん）とされています。',
            3: 'かんむりざはかんむりをえがいた小さな半円形の星ざです。ギリシア神話では、酒神ディオニソスがクレタ島の王女アリアドネにおくった美しい宝冠（ほうかん）とされています。',
            4: 'かんむりざはかんむりをえがいた小さな半円形の星ざです。ギリシア神話では、酒神ディオニソスがクレタ島の王女アリアドネにおくった美しい宝冠（ほうかん）とされています。',
            5: 'かんむりざはかんむりをえがいた小さな半円形の星ざです。ギリシア神話では、酒神ディオニソスがクレタ島の王女アリアドネにおくった美しい宝冠（ほうかん）とされています。',
            6: 'かんむり座はかんむりをえがいた小さな半円形の星座です。ギリシア神話では、酒神ディオニソスがクレタ島の王女アリアドネにおくった美しい宝冠（ほうかん）とされています。',
        }
    },
    {code: 20, category: 1,
        label: { default: 'ぎょしゃ', 1: 'ぎょしゃ', 2: 'ぎょしゃ', 3: 'ぎょしゃ', 4: 'ぎょしゃ', 5: 'ぎょしゃ', 6: 'ぎょしゃ'},
        phrase: {
            default: 'ぎょしゃ座は、やぎを抱く老人の姿がえがかれています。この老人のモデルとされるアテネの王エリクトニウスは生まれつき足が不自由で歩くことができませんでしたが、馬車を発明して多くの戦に勝利しました。その姿が称えられ、ぎょしゃ座となったと伝えられています。',
            1: 'ぎょしゃざは、やぎをだくろう人のすがたがえがかれています。このろう人のモデルとされるアテネの王エリクトニウスは 生まれつき足がふじゆうで あるくことができませんでしたが、ば車をはつめいして おおくのいくさにしょうりしました。そのすがたがたたえられ、ぎょしゃざとなったとつたえられています。',
            2: 'ぎょしゃざは、やぎをだくろうじんのすがたがえがかれています。このろうじんのモデルとされるアテネの王エリクトニウスは 生まれつき足がふ自ゆうで歩くことができませんでしたが、馬車を発明（はつめい）して多くのいくさにしょうりしました。そのすがたがたたえられ、ぎょしゃざとなったとつたえられています。',
            3: 'ぎょしゃざは、やぎをだくろうじんのすがたがえがかれています。このろうじんのモデルとされるアテネの王エリクトニウスは 生まれつき足がふ自由で歩くことができませんでしたが、馬車を発明して多くのいくさに勝りしました。そのすがたがたたえられ、ぎょしゃざとなったとつたえられています。',
            4: 'ぎょしゃざは、やぎをだく老人のすがたがえがかれています。この老人のモデルとされるアテネの王エリクトニウスは 生まれつき足が不自由で歩くことができませんでしたが、馬車を発明して多くの戦に勝利しました。そのすがたがたたえられ、ぎょしゃざとなったと伝えられています。',
            5: 'ぎょしゃざは、やぎをだく老人のすがたがえがかれています。この老人のモデルとされるアテネの王エリクトニウスは 生まれつき足が不自由で歩くことができませんでしたが、馬車を発明して多くの戦に勝利しました。そのすがたがたたえられ、ぎょしゃざとなったと伝えられています。',
            6: 'ぎょしゃ座は、やぎをだく老人の姿がえがかれています。この老人のモデルとされるアテネの王エリクトニウスは 生まれつき足が不自由で歩くことができませんでしたが、馬車を発明して多くの戦に勝利しました。その姿がとなえられ、ぎょしゃ座となったと伝えられています。',
        }
    },
    {code: 21, category: 1,
        label: { default: 'くじゃく', 1: 'くじゃく', 2: 'くじゃく', 3: 'くじゃく', 4: 'くじゃく', 5: 'くじゃく', 6: 'くじゃく'},
        phrase: {
            default: '1600年代に作られた新しい星座のため、星座にまつわる神話や伝承はありません。',
            1: '1600年だいにつくられたあたらしいせいざのため、せいざにまつわるしんわやでんしょうはありません。',
            2: '1600年だいに作られた新しい星ざのため、星ざにまつわるしん話やでんしょうはありません。',
            3: '1600年代に作られた新しい星ざのため、星ざにまつわる神話やでんしょうはありません。',
            4: '1600年代に作られた新しい星ざのため、星ざにまつわる神話や伝しょうはありません。',
            5: '1600年代に作られた新しい星ざのため、星ざにまつわる神話や伝承はありません。',
            6: '1600年代に作られた新しい星座のため、星座にまつわる神話や伝承はありません。',
        }
    },
    {code: 22, category: 1,
        label: { default: 'くじら', 1: 'くじら', 2: 'くじら', 3: 'くじら', 4: 'くじら', 5: 'くじら', 6: 'くじら'},
        phrase: {
            default: 'くじら座のモデルは海の怪物ケートスという化けクジラで、私達がイメージするクジラとは姿が違います。ギリシア神話ではアンドロメダ姫を食べようとして英雄ペルセウスに石にされてしまいました。',
            1: 'くじらざのモデルは うみのかいぶつケートスというばけクジラで、わたしたちがイメージするクジラとは すがたがちがいます。ギリシアしんわではアンドロメダひめをたべようとして えいゆうペルセウスに石にされてしまいました。',
            2: 'くじらざのモデルは海のかいぶつケートスというばけクジラで、わたしたちがイメージするクジラとは すがたがちがいます。ギリシアしん話ではアンドロメダひめを食べようとして えいゆうペルセウスに石にされてしまいました。',
            3: 'くじらざのモデルは海の怪物（かいぶつ）ケートスという化けクジラで、わたしたちがイメージするクジラとは すがたがちがいます。ギリシア神話ではアンドロメダひめを食べようとして えいゆうペルセウスに石にされてしまいました。',
            4: 'くじらざのモデルは海の怪物（かいぶつ）ケートスという化けクジラで、わたし達がイメージするクジラとは すがたがちがいます。ギリシア神話ではアンドロメダひめを食べようとして英ゆうペルセウスに石にされてしまいました。',
            5: 'くじらざのモデルは海の怪物（かいぶつ）ケートスという化けクジラで、わたし達がイメージするクジラとは すがたがちがいます。ギリシア神話ではアンドロメダひめを食べようとして英ゆうペルセウスに石にされてしまいました。',
            6: 'くじら座のモデルは海の怪物（かいぶつ）ケートスという化けクジラで、私達がイメージするクジラとは姿がちがいます。ギリシア神話ではアンドロメダひめを食べようとして英ゆうペルセウスに石にされてしまいました。',
        }
    },
    {code: 23, category: 1,
        label: { default: 'ケフェウス', 1: 'ケフェウス', 2: 'ケフェウス', 3: 'ケフェウス', 4: 'ケフェウス', 5: 'ケフェウス', 6: 'ケフェウス'},
        phrase: {
            default: 'このケフェウスざは、古代エチオピア国の王で、アンドロメダの父親として登場する神話が有名です。カシオペヤ座、アンドロメダ座、ケフェウス座、ペルセウス座の４星座は、古代エチオピア王家の４星座と呼ばれています。',
            1: 'このケフェウスざは、こだいエチオピアこくの王で、アンドロメダのちちおやとして とうじょうするしんわがゆうめいです。カシオペヤざ、アンドロメダざ、ケフェウスざ、ペルセウスざの４せいざは、こだいエチオピア王けの４せいざとよばれています。',
            2: 'このケフェウスざは、こだいエチオピア国の王で、アンドロメダの父親としてとう場するしん話がゆうめいです。カシオペヤざ、アンドロメダざ、ケフェウスざ、ペルセウスざの４星ざは、こだいエチオピア王家の４星ざとよばれています。',
            3: 'このケフェウスざは、古代エチオピア国の王で、アンドロメダの父親として登場する神話が有名です。カシオペヤざ、アンドロメダざ、ケフェウスざ、ペルセウスざの４星ざは、古代エチオピア王家の４星ざとよばれています。',
            4: 'このケフェウスざは、古代エチオピア国の王で、アンドロメダの父親として登場する神話が有名です。カシオペヤざ、アンドロメダざ、ケフェウスざ、ペルセウスざの４星ざは、古代エチオピア王家の４星ざとよばれています。',
            5: 'このケフェウスざは、古代エチオピア国の王で、アンドロメダの父親として登場する神話が有名です。カシオペヤざ、アンドロメダざ、ケフェウスざ、ペルセウスざの４星ざは、古代エチオピア王家の４星ざとよばれています。',
            6: 'このケフェウス座は、古代エチオピア国の王で、アンドロメダの父親として登場する神話が有名です。カシオペヤ座、アンドロメダ座、ケフェウス座、ペルセウス座の４星座は、古代エチオピア王家の４星座と呼ばれています。',
        }
    },
    {code: 24, category: 1,
        label: { default: 'ケンタウルス', 1: 'ケンタウルス', 2: 'ケンタウルス', 3: 'ケンタウルス', 4: 'ケンタウルス', 5: 'ケンタウルス', 6: 'ケンタウルス'},
        phrase: {
            default: 'ケンタウルス座は、英雄ヘルクレスの冒険を助けたケンタウルス族のフォローという立派な馬人がモデルだとされています。',
            1: 'ケンタウルスざは、えいゆうヘルクレスのぼうけんをたすけたケンタウルスぞくの フォローというりっぱなうま人がモデルだとされています。',
            2: 'ケンタウルスざは、えいゆうヘルクレスのぼうけんをたすけたケンタウルスぞくの フォローというりっぱな馬人がモデルだとされています。',
            3: 'ケンタウルスざは、えいゆうヘルクレスのぼうけんを助けたケンタウルス族のフォローというりっぱな馬人がモデルだとされています。',
            4: 'ケンタウルスざは、英ゆうヘルクレスのぼうけんを助けたケンタウルス族のフォローという立派（りっぱ）な馬人がモデルだとされています。',
            5: 'ケンタウルスざは、英ゆうヘルクレスのぼう険を助けたケンタウルス族のフォローという立派（りっぱ）な馬人がモデルだとされています。',
            6: 'ケンタウルス座は、英ゆうヘルクレスのぼう険を助けたケンタウルス族のフォローという立派な馬人がモデルだとされています。',
        }
    },
    {code: 25, category: 1,
        label: { default: 'こいぬ', 1: 'こいぬ', 2: 'こいぬ', 3: 'こいぬ', 4: 'こいぬ', 5: 'こいぬ', 6: 'こいぬ'},
        phrase: {
            default: 'こいぬ座は、ギリシア神話では狩人アクタイオンの猟犬といわれています。また「おおいぬ座」とともに狩人オリオンが連れていたともいわれています。',
            1: 'こいぬざは、ギリシアしんわでは狩人（かりうど）アクタイオンのりょう犬といわれています。また「おおいぬざ」とともに狩人（かりうど）オリオンがつれていたともいわれています。',
            2: 'こいぬざは、ギリシアしん話では狩人（かりうど）アクタイオンのりょう犬といわれています。また「おおいぬざ」とともに狩人（かりうど）オリオンがつれていたともいわれています',
            3: 'こいぬざは、ギリシア神話では狩人（かりうど）アクタイオンのりょう犬といわれています。また「おおいぬざ」とともに狩人（かりうど）オリオンがつれていたともいわれています。',
            4: 'こいぬざは、ギリシア神話では狩人（かりうど）アクタイオンのりょう犬といわれています。また「おおいぬざ」とともに狩人（かりうど）オリオンが連れていたともいわれています。',
            5: 'こいぬざは、ギリシア神話では狩人（かりうど）アクタイオンのりょう犬といわれています。また「おおいぬざ」とともに狩人（かりうど）オリオンが連れていたともいわれています。',
            6: 'こいぬ座は、ギリシア神話では狩人（かりうど）アクタイオンのりょう犬といわれています。また「おおいぬ座」とともに狩人（かりうど）オリオンが連れていたともいわれています。',
        }
    },
    {code: 26, category: 1,
        label: { default: 'こぐま', 1: 'こぐま', 2: 'こぐま', 3: 'こぐま', 4: 'こぐま', 5: 'こぐま', 6: 'こぐま'},
        phrase: {
            default: 'こぐま座は、おおぐま座になったカリストの子供、アルカスの姿としてギリシア神話に登場します。',
            1: 'こぐまざは、おおぐまざになったカリストの子ども、アルカスのすがたとしてギリシアしんわにとうじょうします。',
            2: 'こぐまざは、おおぐまざになったカリストの子ども、アルカスのすがたとしてギリシアしん話にとう場します。',
            3: 'こぐまざは、おおぐまざになったカリストの子ども、アルカスのすがたとしてギリシア神話に登場します。',
            4: 'こぐまざは、おおぐまざになったカリストの子ども、アルカスのすがたとしてギリシア神話に登場します。',
            5: 'こぐまざは、おおぐまざになったカリストの子ども、アルカスのすがたとしてギリシア神話に登場します。',
            6: 'こぐま座は、おおぐま座になったカリストの子供、アルカスの姿としてギリシア神話に登場します。',
        }
    },
    {code: 27, category: 1,
        label: { default: 'コップ', 1: 'コップ', 2: 'コップ', 3: 'コップ', 4: 'コップ', 5: 'コップ', 6: 'コップ'},
        phrase: {
            default: 'コップ座のコップとは私達がよく使う小さいコップではなく大きな杯です。このコップの持ち主は、酒の神ディオニュソスの他に、アポロン、ヘルクレス、アキレスなど多く説があります。',
            1: 'コップざのコップとは わたしたちがよくつかう 小さいコップではなく 大きなさかずきです。このコップのもちぬしは、さけのかみディオニュソスのほかに、アポロン、ヘルクレス、アキレスなどおおくせつがあります。',
            2: 'コップざのコップとはわたしたちがよくつかう 小さいコップではなく 大きなさかずきです。このコップのもちぬしは、さけのかみディオニュソスのほかに、アポロン、ヘルクレス、アキレスなど多くせつがあります。',
            3: 'コップざのコップとはわたしたちがよく使う小さいコップではなく大きなさかずきです。このコップの持ち主は、酒の神ディオニュソスの他に、アポロン、ヘルクレス、アキレスなど多くせつがあります。',
            4: 'コップざのコップとはわたし達がよく使う小さいコップではなく大きなさかずきです。このコップの持ち主は、酒の神ディオニュソスの他に、アポロン、ヘルクレス、アキレスなど多く説があります。',
            5: 'コップざのコップとはわたし達がよく使う小さいコップではなく大きなさかずきです。このコップの持ち主は、酒の神ディオニュソスの他に、アポロン、ヘルクレス、アキレスなど多く説があります。',
            6: 'コップ座のコップとは私達がよく使う小さいコップではなく大きなさかずきです。このコップの持ち主は、酒の神ディオニュソスの他に、アポロン、ヘルクレス、アキレスなど多く説があります。',
        }
    },
    {code: 28, category: 1,
        label: { default: 'こと', 1: 'こと', 2: 'こと', 3: 'こと', 4: 'こと', 5: 'こと', 6: 'こと'},
        phrase: {
            default: 'こと座は、ギリシア神話に登場する音楽家オルフェウスが使っていた竪琴だといわれています。',
            1: 'ことざは、ギリシアしんわにとうじょうする 音がくかオルフェウスがつかっていた たてごとだといわれています。',
            2: 'ことざは、ギリシアしん話にとう場する音楽家（おんがくか）オルフェウスがつかっていた たてごとだといわれています。',
            3: 'ことざは、ギリシア神話に登場する音楽家オルフェウスが使っていた たてごとだといわれています。',
            4: 'ことざは、ギリシア神話に登場する音楽家オルフェウスが使っていた たてごとだといわれています。',
            5: 'ことざは、ギリシア神話に登場する音楽家オルフェウスが使っていた たてごとだといわれています。',
            6: 'こと座は、ギリシア神話に登場する音楽家オルフェウスが使っていた たてごとだといわれています。',
        }
    },
    {code: 29, category: 1,
        label: { default: 'コンパス', 1: 'コンパス', 2: 'コンパス', 3: 'コンパス', 4: 'コンパス', 5: 'コンパス', 6: 'コンパス'},
        phrase: {
            default: 'コンパス座は18世紀に作られた新しい星座のため、星座にまつわる神話や伝承はありません。',
            1: 'コンパスざは 18せいきにつくられたあたらしいせいざのため、せいざにまつわるしんわやでんしょうはありません。',
            2: 'コンパスざは18せいきに作られた新しい星ざのため、星ざにまつわるしん話やでんしょうはありません。',
            3: 'コンパスざは18世きに作られた新しい星ざのため、星ざにまつわる神話やでんしょうはありません。',
            4: 'コンパスざは18世紀に作られた新しい星ざのため、星ざにまつわる神話や伝しょうはありません。',
            5: 'コンパスざは18世紀に作られた新しい星ざのため、星ざにまつわる神話や伝承はありません。',
            6: 'コンパス座は18世紀に作られた新しい星座のため、星座にまつわる神話や伝承はありません。',
        }
    },
    {code: 30, category: 1,
        label: { default: 'さそり', 1: 'さそり', 2: 'さそり', 3: 'さそり', 4: 'さそり', 5: 'さそり', 6: 'さそり'},
        phrase: {
            default: 'さそり座は、オリオンを毒針で刺した功績で星座になりました。オリオンは今でもサソリを恐れ、東の空からさそり座がのぼると、西の地平線に逃げ隠れるといわれています。',
            1: 'さそりざは、オリオンをどくばりでさしたこうせきで せいざになりました。オリオンはいまでもサソリをおそれ、ひがしの空からさそりざがのぼると、にしのちへいせんに にげかくれるといわれています。',
            2: 'さそりざは、オリオンをどくばりでさしたこうせきで星ざになりました。オリオンは今でもサソリをおそれ、東の空からさそりざがのぼると、西の地へい線ににげかくれるといわれています。',
            3: 'さそりざは、オリオンをどくばりでさしたこうせきで星ざになりました。オリオンは今でもサソリをおそれ、東の空からさそりざがのぼると、西の地平線ににげかくれるといわれています。',
            4: 'さそりざは、オリオンを毒ばりでさした功せきで星ざになりました。オリオンは今でもサソリをおそれ、東の空からさそりざがのぼると、西の地平線ににげかくれるといわれています。',
            5: 'さそりざは、オリオンを毒ばりでさした功績で星ざになりました。オリオンは今でもサソリをおそれ、東の空からさそりざがのぼると、西の地平線ににげかくれるといわれています。',
            6: 'さそり座は、オリオンを毒針でさした功績で星座になりました。オリオンは今でもサソリをおそれ、東の空からさそり座がのぼると、西の地平線ににげかくれるといわれています。',
        }
    },
    {code: 31, category: 1,
        label: { default: 'しし', 1: 'しし', 2: 'しし', 3: 'しし', 4: 'しし', 5: 'しし', 6: 'しし'},
        phrase: {
            default: 'ギリシア神話によると、しし座はネメアの森に住む人食いライオンのことで、勇者ヘルクレスに退治されて星座になったということです。',
            1: 'ギリシアしんわによると、ししざはネメアの森にすむ 人くいいライオンのことで、ゆうしゃヘルクレスにたいじされて せいざになったということです。',
            2: 'ギリシアしん話によると、ししざはネメアの森にすむ 人食いライオンのことで、ゆうしゃヘルクレスにたいじされて星ざになったということです。',
            3: 'ギリシア神話によると、ししざはネメアの森に住む人食いライオンのことで、ゆう者ヘルクレスにたいじされて星ざになったということです。',
            4: 'ギリシア神話によると、ししざはネメアの森に住む人食いライオンのことで、勇者ヘルクレスに退治（たいじ）されて星ざになったということです。',
            5: 'ギリシア神話によると、ししざはネメアの森に住む人食いライオンのことで、勇者ヘルクレスに退治されて星ざになったということです。',
            6: 'ギリシア神話によると、しし座はネメアの森に住む人食いライオンのことで、勇者ヘルクレスに退治されて星座になったということです。',
        }
    },
    {code: 32, category: 1,
        label: { default: 'つる', 1: 'つる', 2: 'つる', 3: 'つる', 4: 'つる', 5: 'つる', 6: 'つる'},
        phrase: {
            default: 'つる座は17世紀に作られた新しい星座のため、星座にまつわる神話や伝承はありません。',
            1: 'つるざは17せいきにつくられたあたらしいせいざのため、せいざにまつわるしんわやでんしょうはありません。',
            2: 'つるざは17せいきに作られた新しい星ざのため、星ざにまつわるしん話やでんしょうはありません。',
            3: 'つるざは17世きに作られた新しい星ざのため、星ざにまつわる神話やでんしょうはありません。',
            4: 'つるざは17世紀に作られた新しい星ざのため、星ざにまつわる神話や伝しょうはありません。',
            5: 'つるざは17世紀に作られた新しい星ざのため、星ざにまつわる神話や伝承はありません。',
            6: 'つる座は17世紀に作られた新しい星座のため、星座にまつわる神話や伝承はありません。',
        }
    },
    {code: 33, category: 1,
        label: { default: 'てんびん', 1: 'てんびん', 2: 'てんびん', 3: 'てんびん', 4: 'てんびん', 5: 'てんびん', 6: 'てんびん'},
        phrase: {
            default: 'てんびん座は、ギリシア神話で正義の女神アストライアが手に持っている、正義を計るてんびんだとされています。また、昔は太陽がてんびん座を通過するころは昼と夜の時間が等かったため、そのつり合いをてんびんとして表したともいわれています。',
            1: 'てんびんざは、ギリシアしんわで正ぎのめがみアストライアが手にもっている、正ぎをはかるてんびんだとされています。また、むかしはたいようがてんびんざをつうかするころは ひるとよるのじかんがひとしかったため、そのつりあいをてんびんとして あらわしたともいわれています。',
            2: 'てんびんざは、ギリシアしん話で正ぎのめがみアストライアが手にもっている、正ぎを計るてんびんだとされています。また、むかしは太陽（たいよう）がてんびんざを通過（つうか）するころは昼と夜の時間がひとしかったため、そのつり合いをてんびんとして あらわしたともいわれています。',
            3: 'てんびんざは、ギリシア神話で正ぎの女神アストライアが手に持っている、正ぎを計るてんびんだとされています。また、昔は太陽がてんびんざを通過（つうか）するころは昼と夜の時間が等しかったため、そのつり合いをてんびんとして表したともいわれています。',
            4: 'てんびんざは、ギリシア神話で正ぎの女神アストライアが手に持っている、正ぎを計るてんびんだとされています。また、昔は太陽がてんびんざを通過（つうか）するころは昼と夜の時間が等しかったため、そのつり合いをてんびんとして表したともいわれています。',
            5: 'てんびんざは、ギリシア神話で正義の女神アストライアが手に持っている、正義を計るてんびんだとされています。また、昔は太陽がてんびんざを通過するころは昼と夜の時間が等しかったため、そのつり合いをてんびんとして表したともいわれています。',
            6: 'てんびん座は、ギリシア神話で正義の女神アストライアが手に持っている、正義を計るてんびんだとされています。また、昔は太陽がてんびん座を通過するころは昼と夜の時間が等かったため、そのつり合いをてんびんとして表したともいわれています。',
        }
    },
    {code: 34, category: 1,
        label: { default: 'とも', 1: 'とも', 2: 'とも', 3: 'とも', 4: 'とも', 5: 'とも', 6: 'とも'},
        phrase: {
            default: '「とも」とは船尾のことで、神話に登場する大きな船の後ろの部分を星座にしたものです。元はアルゴ座という大きな船の形をした星座の一部で、近世になって大きすぎるという理由で4つに分割されたうちのひとつです。',
            1: '「とも」とは船尾（せんび）のことで、しんわにとうじょうする 大きなふねのうしろのぶぶんをせいざにしたものです。もとはアルゴざという 大きなふねのかたちをしたせいざの一ぶで、きんせいになって大きすぎるというりゆうで 4つにぶんかつされたうちのひとつです。',
            2: '「とも」とは船尾（せんび）のことで、しん話にとう場する大きな船の後ろの部分（ぶぶん）を星ざにしたものです。元はアルゴざという大きな船の形をした星ざのいちぶで、近せいになって大きすぎるという理由（りゆう）で4つに分割（ぶんかつ）されたうちのひとつです。',
            3: '「とも」とは船尾（せんび）のことで、神話に登場する大きな船の後ろの部分を星ざにしたものです。元はアルゴざという大きな船の形をした星ざの一部で、近世になって大きすぎるという理由で4つに分割（ぶんかつ）されたうちのひとつです。',
            4: '「とも」とは船尾（せんび）のことで、神話に登場する大きな船の後ろの部分を星ざにしたものです。元はアルゴざという大きな船の形をした星ざの一部で、近世になって大きすぎるという理由で4つに分割（ぶんかつ）されたうちのひとつです。',
            5: '「とも」とは船尾（せんび）のことで、神話に登場する大きな船の後ろの部分を星ざにしたものです。元はアルゴざという大きな船の形をした星ざの一部で、近世になって大きすぎるという理由で4つに分割（ぶんかつ）されたうちのひとつです。',
            6: '「とも」とは船尾（せんび）のことで、神話に登場する大きな船の後ろの部分を星座にしたものです。元はアルゴ座という大きな船の形をした星座の一部で、近世になって大きすぎるという理由で4つに分割されたうちのひとつです。',
        }
    },
    {code: 35, category: 1,
        label: { default: 'はくちょう', 1: 'はくちょう', 2: 'はくちょう', 3: 'はくちょう', 4: 'はくちょう', 5: 'はくちょう', 6: 'はくちょう'},
        phrase: {
            default: 'はくちょう座の十字の形はハクチョウが翼を大きく広げて空を飛んでいる姿を表しています。スパルタの王妃レダの美しさにひかれた大神ゼウスは、白鳥になってレダへと近づいたという神話があります。',
            1: 'はくちょうざの十字のかたちは ハクチョウがつばさを大きくひろげて空をとんでいる すがたをあらわしています。スパルタの王ひレダの うつくしさにひかれた大かみゼウスは、白ちょうになってレダへとちかづいたというしんわがあります。',
            2: 'はくちょうざの十字の形はハクチョウがつばさを大きく広げて空をとんでいるすがたをあらわしています。スパルタの王ひレダのうつくしさにひかれた大かみゼウスは、白鳥になってレダへと近づいたというしん話があります。',
            3: 'はくちょうざの十字の形はハクチョウがつばさを大きく広げて空をとんでいるすがたを表しています。スパルタの王ひレダの美しさにひかれた大神ゼウスは、白鳥になってレダへと近づいたという神話があります。',
            4: 'はくちょうざの十字の形はハクチョウがつばさを大きく広げて空を飛んでいるすがたを表しています。スパルタの王ひレダの美しさにひかれた大神ゼウスは、白鳥になってレダへと近づいたという神話があります。',
            5: 'はくちょうざの十字の形はハクチョウがつばさを大きく広げて空を飛んでいるすがたを表しています。スパルタの王ひレダの美しさにひかれた大神ゼウスは、白鳥になってレダへと近づいたという神話があります。',
            6: 'はくちょう座の十字の形はハクチョウがつばさを大きく広げて空を飛んでいる姿を表しています。スパルタの王ひレダの美しさにひかれた大神ゼウスは、白鳥になってレダへと近づいたという神話があります。',
        }
    },
    {code: 36, category: 1,
        label: { default: 'はと', 1: 'はと', 2: 'はと', 3: 'はと', 4: 'はと', 5: 'はと', 6: 'はと'},
        phrase: {
            default: '旧約聖書のノアの方舟の物語に登場し、洪水がおさまったことを知らせる鳩がモデルといわれています。',
            1: 'きゅうやくせいしょのノアのはこぶね のものがたりにとうじょうし、こう水がおさまったことをしらせる はとがモデルといわれています。',
            2: 'きゅうやくせい書のノアの方舟（はこぶね）の物語（ものがたり）にとう場し、こうずいがおさまったことを知らせるはとがモデルといわれています。',
            3: 'きゅうやくせい書のノアの方舟（はこぶね）の物語に登場し、こうずいがおさまったことを知らせるはとがモデルといわれています。',
            4: 'きゅう約せい書のノアの方舟（はこぶね）の物語に登場し、洪水（こうずい）がおさまったことを知らせるはとがモデルといわれています。',
            5: '旧約せい書のノアの方舟（はこぶね）の物語に登場し、洪水（こうずい）がおさまったことを知らせるはとがモデルといわれています。',
            6: '旧約聖書のノアの方舟（はこぶね）の物語に登場し、洪水（こうずい）がおさまったことを知らせるはとがモデルといわれています。',
        }
    },
    {code: 37, category: 1,
        label: { default: 'ふたご', 1: 'ふたご', 2: 'ふたご', 3: 'ふたご', 4: 'ふたご', 5: 'ふたご', 6: 'ふたご'},
        phrase: {
            default: 'ふたご座のモデルは、白鳥に化けた大神ゼウスがスパルタの王妃レダに生ませた双子の兄弟カストルとポルックスであるといわれています。',
            1: 'ふたござのモデルは、白ちょうにばけた大かみゼウスが スパルタの王ひレダに生ませたふたごのきょうだい カストルとポルックスであるといわれています。',
            2: 'ふたござのモデルは、白鳥にばけた大かみゼウスがスパルタの王ひレダに生ませたふたごの兄弟カストルとポルックスであるといわれています。',
            3: 'ふたござのモデルは、白鳥に化けた大神ゼウスがスパルタの王ひレダに生ませたふたごの兄弟カストルとポルックスであるといわれています。',
            4: 'ふたござのモデルは、白鳥に化けた大神ゼウスがスパルタの王ひレダに生ませた双子（ふたご）の兄弟カストルとポルックスであるといわれています。',
            5: 'ふたござのモデルは、白鳥に化けた大神ゼウスがスパルタの王ひレダに生ませた双子（ふたご）の兄弟カストルとポルックスであるといわれています。',
            6: 'ふたご座のモデルは、白鳥に化けた大神ゼウスがスパルタの王ひレダに生ませた双子（ふたご）の兄弟カストルとポルックスであるといわれています。',
        }
    },
    {code: 38, category: 1,
        label: { default: 'ペガスス', 1: 'ペガスス', 2: 'ペガスス', 3: 'ペガスス', 4: 'ペガスス', 5: 'ペガスス', 6: 'ペガスス'},
        phrase: {
            default: 'ペガスス座は、勇者ペルセウスがメドゥーサを倒した時に生まれた天馬で、ペルセウスと共にアンドロメダ姫を助けたという神話が有名です。',
            1: 'ペガススざは、ゆうしゃペルセウスがメドゥーサをたおしたときに生まれた天まで、ペルセウスとともにアンドロメダひめをたすけたというしんわがゆうめいです。',
            2: 'ペガススざは、ゆうしゃペルセウスがメドゥーサをたおした時に生まれた天馬で、ペルセウスとともにアンドロメダひめをたすけたというしん話がゆうめいです。',
            3: 'ペガススざは、ゆう者ペルセウスがメドゥーサをたおした時に生まれた天馬で、ペルセウスとともにアンドロメダひめを助けたという神話が有名です。',
            4: 'ペガススざは、勇者ペルセウスがメドゥーサをたおした時に生まれた天馬で、ペルセウスと共にアンドロメダひめを助けたという神話が有名です。',
            5: 'ペガススざは、勇者ペルセウスがメドゥーサをたおした時に生まれた天馬で、ペルセウスと共にアンドロメダひめを助けたという神話が有名です。',
            6: 'ペガスス座は、勇者ペルセウスがメドゥーサをたおした時に生まれた天馬で、ペルセウスと共にアンドロメダひめを助けたという神話が有名です。',
        }
    },
    {code: 39, category: 1,
        label: { default: 'へび', 1: 'へび', 2: 'へび', 3: 'へび', 4: 'へび', 5: 'へび', 6: 'へび'},
        phrase: {
            default: '医神アスクレピオス（へびつかい座）にからみつく蛇 の姿を表した星座です。このへび座は健康のシンボル、医術のシンボルとされています。',
            1: 'いしんアスクレピオス（へびつかいざ）にからみつく へびのすがたをあらわしたせいざです。このへびざはけんこうのシンボル、いじゅつのシンボルとされています。',
            2: 'いしんアスクレピオス（へびつかいざ）にからみつくへびのすがたをあらわした星ざです。このへびざはけんこうのシンボル、いじゅつのシンボルとされています。',
            3: '医神アスクレピオス（へびつかいざ）にからみつくへびのすがたを表した星ざです。このへびざはけんこうのシンボル、医じゅつのシンボルとされています。',
            4: '医神アスクレピオス（へびつかいざ）にからみつくへびのすがたを表した星ざです。このへびざは健康のシンボル、医じゅつのシンボルとされています。',
            5: '医神アスクレピオス（へびつかいざ）にからみつくへびのすがたを表した星ざです。このへびざは健康のシンボル、医術のシンボルとされています。',
            6: '医神アスクレピオス（へびつかい座）にからみつくへびの姿を表した星座です。このへび座は健康のシンボル、医術のシンボルとされています。',
        }
    },
    {code: 40, category: 1,
        label: { default: 'へびつかい', 1: 'へびつかい', 2: 'へびつかい', 3: 'へびつかい', 4: 'へびつかい', 5: 'へびつかい', 6: 'へびつかい'},
        phrase: {
            default: 'へびつかい座は、医者のアスクレピオスの姿だとされています。へびは医学の象徴であると同時にアスクレピオスの使いであるといわれています。',
            1: 'へびつかいざは、いしゃのアスクレピオスのすがただとされています。へびはいがくのしょうちょうであるとどうじに アスクレピオスのつかいであるといわれています。',
            2: 'へびつかいざは、いしゃのアスクレピオスのすがただとされています。へびはいがくのしょうちょうであると同時にアスクレピオスのつかいであるといわれています。',
            3: 'へびつかいざは、医者のアスクレピオスのすがただとされています。へびは医学のしょうちょうであると同時にアスクレピオスの使いであるといわれています。',
            4: 'へびつかいざは、医者のアスクレピオスのすがただとされています。へびは医学の象ちょうであると同時にアスクレピオスの使いであるといわれています。',
            5: 'へびつかいざは、医者のアスクレピオスのすがただとされています。へびは医学の象ちょうであると同時にアスクレピオスの使いであるといわれています。',
            6: 'へびつかい座は、医者のアスクレピオスの姿だとされています。へびは医学の象ちょうであると同時にアスクレピオスの使いであるといわれています。',
        }
    },
    {code: 41, category: 1,
        label: { default: 'ヘルクレス', 1: 'ヘルクレス', 2: 'ヘルクレス', 3: 'ヘルクレス', 4: 'ヘルクレス', 5: 'ヘルクレス', 6: 'ヘルクレス'},
        phrase: {
            default: 'ヘルクレス座のモデルである、大神ゼウスの息子ヘルクレスは、しし（しし座）やヒドラ（うみへび座）を退治した神話があります。12の冒険に出てその功績により星座になったとされています。',
            1: 'ヘルクレスざのモデルである、大かみゼウスのむす子ヘルクレスは、しし（ししざ）やヒドラ（うみへびざ）をたいじしたしんわがあります。12のぼうけんに出てそのこうせきによりせいざになったとされています。',
            2: 'ヘルクレスざのモデルである、大かみゼウスのむすこヘルクレスは、しし（ししざ）やヒドラ（うみへびざ）をたいじしたしん話があります。12のぼうけんに出てそのこうせきにより星ざになったとされています。',
            3: 'ヘルクレスざのモデルである、大神ゼウスの息子ヘルクレスは、しし（ししざ）やヒドラ（うみへびざ）をたいじした神話があります。12のぼうけんに出てそのこうせきにより星ざになったとされています。',
            4: 'ヘルクレスざのモデルである、大神ゼウスの息子ヘルクレスは、しし（ししざ）やヒドラ（うみへびざ）をたい治した神話があります。12のぼうけんに出てその功せきにより星ざになったとされています。',
            5: 'ヘルクレスざのモデルである、大神ゼウスの息子ヘルクレスは、しし（ししざ）やヒドラ（うみへびざ）を退治した神話があります。12のぼう険に出てその功績により星ざになったとされています。',
            6: 'ヘルクレス座のモデルである、大神ゼウスの息子ヘルクレスは、しし（しし座）やヒドラ（うみへび座）を退治した神話があります。12のぼう険に出てその功績により星座になったとされています。',
        }
    },
    {code: 42, category: 1,
        label: { default: 'ペルセウス', 1: 'ペルセウス', 2: 'ペルセウス', 3: 'ペルセウス', 4: 'ペルセウス', 5: 'ペルセウス', 6: 'ペルセウス'},
        phrase: {
            default: 'ペルセウス座は、ギリシア神話ではアンドロメダ姫を襲った化けクジラ（くじら座）を退治した英雄ペルセウスがモデルといわれています。',
            1: 'ペルセウスざは、ギリシアしんわではアンドロメダひめをおそった ばけクジラ（くじらざ）をたいじしたえいゆう ペルセウスがモデルといわれています。',
            2: 'ペルセウスざは、ギリシアしん話ではアンドロメダひめをおそったばけクジラ（くじらざ）をたいじしたえいゆうペルセウスがモデルといわれています。',
            3: 'ペルセウスざは、ギリシア神話ではアンドロメダひめをおそった化けクジラ（くじらざ）をたいじしたえいゆうペルセウスがモデルといわれています。',
            4: 'ペルセウスざは、ギリシア神話ではアンドロメダひめをおそった化けクジラ（くじらざ）をたい治した英ゆうペルセウスがモデルといわれています。',
            5: 'ペルセウスざは、ギリシア神話ではアンドロメダひめをおそった化けクジラ（くじらざ）を退治した英ゆうペルセウスがモデルといわれています。',
            6: 'ペルセウス座は、ギリシア神話ではアンドロメダひめをおそった化けクジラ（くじら座）を退治した英ゆうペルセウスがモデルといわれています。',
        }
    },
    {code: 43, category: 1,
        label: { default: 'ほ', 1: 'ほ', 2: 'ほ', 3: 'ほ', 4: 'ほ', 5: 'ほ', 6: 'ほ'},
        phrase: {
            default: '「ほ」は船の「帆」のことで、神話に登場する大きな船の帆のあたりを星座にしたものです。元はアルゴ座という大きな船の形をした星座の一部で、近世になって大きすぎるという理由で4つに分割されたうちのひとつです。',
            1: '「ほ」はふねの「帆（ほ）」のことで、しんわにとうじょうする大きなふねの帆（ほ）のあたりをせいざにしたものです。もとはアルゴざという大きなふねのかたちをしたせいざの一ぶで、きんせいになって大きすぎるというりゆうで 4つにぶんかつされたうちのひとつです。',
            2: '「ほ」は船の「帆（ほ）」のことで、しん話にとう場する大きな船の帆（ほ）のあたりを星ざにしたものです。元はアルゴざという大きな船の形をした星ざのいちぶで、近せいになって大きすぎるという理由（りゆう）で4つに分割（ぶんかつ）されたうちのひとつです。',
            3: '「ほ」は船の「帆（ほ）」のことで、神話に登場する大きな船の帆（ほ）のあたりを星ざにしたものです。元はアルゴざという大きな船の形をした星ざの一部で、近世になって大きすぎるという理由で4つに分割（ぶんかつ）されたうちのひとつです。',
            4: '「ほ」は船の「帆（ほ）」のことで、神話に登場する大きな船の帆（ほ）のあたりを星ざにしたものです。元はアルゴざという大きな船の形をした星ざの一部で、近世になって大きすぎるという理由で4つに分割（ぶんかつ）されたうちのひとつです。',
            5: '「ほ」は船の「帆（ほ）」のことで、神話に登場する大きな船の帆（ほ）のあたりを星ざにしたものです。元はアルゴざという大きな船の形をした星ざの一部で、近世になって大きすぎるという理由で4つに分割（ぶんかつ）されたうちのひとつです。',
            6: '「ほ」は船の「帆（ほ）」のことで、神話に登場する大きな船の帆（ほ）のあたりを星座にしたものです。元はアルゴ座という大きな船の形をした星座の一部で、近世になって大きすぎるという理由で4つに分割されたうちのひとつです。',
        }
    },
    {code: 44, category: 1,
        label: { default: 'ほうおう', 1: 'ほうおう', 2: 'ほうおう', 3: 'ほうおう', 4: 'ほうおう', 5: 'ほうおう', 6: 'ほうおう'},
        phrase: {
            default: 'ほうおう座は16世紀末につくられた新しい星座で、不死鳥フェニックスがモチーフとなっています。',
            1: 'ほうおうざは、16せいきまつにつくられたあたらしいせいざで、ふしちょうフェニックスがモチーフとなっています。',
            2: 'ほうおうざは16せいきまつにつくられた新しい星ざで、不死鳥（ふしちょう）フェニックスがモチーフとなっています。',
            3: 'ほうおうざは16世きまつにつくられた新しい星ざで、不死鳥（ふしちょう）フェニックスがモチーフとなっています。',
            4: 'ほうおうざは16世紀末につくられた新しい星ざで、不死鳥フェニックスがモチーフとなっています。',
            5: 'ほうおうざは16世紀末につくられた新しい星ざで、不死鳥フェニックスがモチーフとなっています。',
            6: 'ほうおう座は16世紀末につくられた新しい星座で、不死鳥フェニックスがモチーフとなっています。',
        }
    },
    {code: 45, category: 1,
        label: { default: 'みずがめ', 1: 'みずがめ', 2: 'みずがめ', 3: 'みずがめ', 4: 'みずがめ', 5: 'みずがめ', 6: 'みずがめ'},
        phrase: {
            default: 'みずがめ座は、ギリシア神話に出てくるガニュメーデスがかかえる大きなみずがめから水が流れ落ちる様子が描かれています。水がめから流れた水は、そのままエリダヌス座の流れになっています。',
            1: 'みずがめざは、ギリシアしんわに出てくるガニュメーデスがかかえる大きなみずがめから 水がながれおちるようすがえがかれています。水がめからながれた水は、そのままエリダヌスざのながれになっています。',
            2: 'みずがめざは、ギリシアしん話に出てくるガニュメーデスがかかえる大きなみずがめから水がながれおちるようすがえがかれています。水がめからながれた水は、そのままエリダヌスざのながれになっています。',
            3: 'みずがめざは、ギリシア神話に出てくるガニュメーデスがかかえる大きなみずがめから水が流れ落ちる様子がえがかれています。水がめから流れた水は、そのままエリダヌスざの流れになっています。',
            4: 'みずがめざは、ギリシア神話に出てくるガニュメーデスがかかえる大きなみずがめから水が流れ落ちる様子がえがかれています。水がめから流れた水は、そのままエリダヌスざの流れになっています。',
            5: 'みずがめざは、ギリシア神話に出てくるガニュメーデスがかかえる大きなみずがめから水が流れ落ちる様子がえがかれています。水がめから流れた水は、そのままエリダヌスざの流れになっています。',
            6: 'みずがめ座は、ギリシア神話に出てくるガニュメーデスがかかえる大きなみずがめから水が流れ落ちる様子がえがかれています。水がめから流れた水は、そのままエリダヌス座の流れになっています。',
        }
    },
    {code: 46, category: 1,
        label: { default: 'みなみじゅうじ', 1: 'みなみじゅうじ', 2: 'みなみじゅうじ', 3: 'みなみじゅうじ', 4: 'みなみじゅうじ', 5: 'みなみじゅうじ', 6: 'みなみじゅうじ'},
        phrase: {
            default: '南の海を航海する船乗り達がこの十字架に航海の安全を祈ったといわれてきており、17世紀にみなみじゅうじ座として設定されました。',
            1: 'みなみのうみをこうかいする ふなのりたちがこの十字架（じゅうじか）に こうかいのあんぜんをいのったといわれてきており、17せいきにみなみじゅうじざとしてせっていされました。',
            2: '南の海をこう海する船のりたちがこの十字架（じゅうじか）にこう海のあんぜんをいのったといわれてきており、17せいきにみなみじゅうじざとしてせっていされました。',
            3: '南の海をこう海する船乗りたちがこの十字架（じゅうじか）にこうかいの安全をいのったといわれてきており、17世きにみなみじゅうじざとして設定（せってい）されました。',
            4: '南の海を航海する船乗り達がこの十字架（じゅうじか）に航海の安全をいのったといわれてきており、17世紀にみなみじゅうじざとして設定（せってい）されました。',
            5: '南の海を航海する船乗り達がこの十字架（じゅうじか）に航海の安全をいのったといわれてきており、17世紀にみなみじゅうじざとして設定されました。',
            6: '南の海を航海する船乗り達がこの十字架（じゅうじか）に航海の安全をいのったといわれてきており、17世紀にみなみじゅうじ座として設定されました。',
        }
    },
    {code: 47, category: 1,
        label: { default: 'みなみのうお', 1: 'みなみのうお', 2: 'みなみのうお', 3: 'みなみのうお', 4: 'みなみのうお', 5: 'みなみのうお', 6: 'みなみのうお'},
        phrase: {
            default: 'ギリシア神話では、神々がナイル川沿いで宴会を開いていたところ、突然怪物テュポンが現れ、驚いた神々は動物に姿をかえ逃げました。その神の一人が魚の形になって逃げたものとされています。',
            1: 'ギリシアしんわでは、神々（かみがみ）がナイル川ぞいでえんかいをひらいていたところ、とつぜんかいぶつテュポンがあらわれ、おどろいた神々（かみがみ）はどうぶつにすがたをかえにげました。そのかみの一人がさかなのかたちになってにげたものとされています。',
            2: 'ギリシアしん話では、神々（かみがみ）がナイル川ぞいでえん会をひらいていたところ、とつぜんかいぶつテュポンがあらわれ、おどろいた神々（かみがみ）はどうぶつにすがたをかえにげました。そのかみの一人が魚の形になってにげたものとされています。',
            3: 'ギリシア神話では、神々（かみがみ）がナイル川ぞいでえん会を開いていたところ、とつぜん怪物（かいぶつ）テュポンがあらわれ、おどろいた神々（かみがみ）は動物にすがたをかえにげました。その神の一人が魚の形になってにげたものとされています。',
            4: 'ギリシア神話では、神々（かみがみ）がナイル川ぞいでえん会を開いていたところ、とつ然怪物（かいぶつ）テュポンがあらわれ、おどろいた神々（かみがみ）は動物にすがたをかえにげました。その神の一人が魚の形になってにげたものとされています。',
            5: 'ギリシア神話では、神々（かみがみ）がナイル川ぞいでえん会を開いていたところ、とつ然怪物（かいぶつ）テュポンが現れ、おどろいた神々（かみがみ）は動物にすがたをかえにげました。その神の一人が魚の形になってにげたものとされています。',
            6: 'ギリシア神話では、神々（かみがみ）がナイル川沿いでえん会を開いていたところ、とつ然怪物（かいぶつ）テュポンが現れ、おどろいた神々（かみがみ）は動物に姿をかえにげました。その神の一人が魚の形になってにげたものとされています。',
        }
    },
    {code: 48, category: 1,
        label: { default: 'やぎ', 1: 'やぎ', 2: 'やぎ', 3: 'やぎ', 4: 'やぎ', 5: 'やぎ', 6: 'やぎ'},
        phrase: {
            default: 'やぎ座は、上半身がやぎで下半身が魚の姿がえがかれています。ギリシア神話では、神々がナイル川沿いで宴会を開いていたところ、突然怪物テュポンが現れ、驚いた神々は動物に姿をかえ逃げました。森の神パンはあわててやぎに化け、川に飛込んだので水中の部分だけが魚になったといいます。',
            1: 'やぎざは、上はんしんがやぎで 下はんしんがさかなのすがたがえがかれています。ギリシアしんわでは、神々（かみがみ）がナイル川ぞいでえんかいをひらいていたところ、とつぜんかいぶつテュポンがあらわれ、おどろいた神々（かみがみ）はどうぶつにすがたをかえにげました。森のかみパンはあわててやぎにばけ、川にとびこんだので水中のぶぶんだけがさかなになったといいます。',
            2: 'やぎざは、上半しんがやぎで下半しんが魚のすがたがえがかれています。ギリシアしん話では、神々（かみがみ）がナイル川ぞいでえん会をひらいていたところ、とつぜんかいぶつテュポンがあらわれ、おどろいた神々（かみがみ）はどうぶつにすがたをかえにげました。森のかみパンはあわててやぎにばけ，川にとびこんだので水中の部分（ぶぶん）だけが魚になったといいます。',
            3: 'やぎざは、上半身がやぎで下半身が魚のすがたがえがかれています。ギリシア神話では、神々（かみがみ）がナイル川ぞいでえん会を開いていたところ、とつぜん怪物（かいぶつ）テュポンがあらわれ、おどろいた神々（かみがみ）は動物にすがたをかえにげました。森の神パンはあわててやぎに化け，川にとびこんだので水中の部分だけが魚になったといいます。',
            4: 'やぎざは、上半身がやぎで下半身が魚のすがたがえがかれています。ギリシア神話では、神々（かみがみ）がナイル川ぞいでえん会を開いていたところ、とつ然怪物（かいぶつ）テュポンがあらわれ、おどろいた神々（かみがみ）は動物にすがたをかえにげました。森の神パンはあわててやぎに化け、川に飛びこんだので水中の部分だけが魚になったといいます。',
            5: 'やぎざは、上半身がやぎで下半身が魚のすがたがえがかれています。ギリシア神話では、神々（かみがみ）がナイル川ぞいでえん会を開いていたところ、とつ然怪物（かいぶつ）テュポンが現れ、おどろいた神々（かみがみ）は動物にすがたをかえにげました。森の神パンはあわててやぎに化け、川に飛びこんだので水中の部分だけが魚になったといいます。',
            6: 'やぎ座は、上半身がやぎで下半身が魚の姿がえがかれています。ギリシア神話では、神々（かみがみ）がナイル川沿いでえん会を開いていたところ、とつ然怪物（かいぶつ）テュポンが現れ、おどろいた神々（かみがみ）は動物に姿をかえにげました。森の神パンはあわててやぎに化け，川に飛こんだので水中の部分だけが魚になったといいます。',
        }
    },
    {code: 49, category: 1,
        label: { default: 'りゅう', 1: 'りゅう', 2: 'りゅう', 3: 'りゅう', 4: 'りゅう', 5: 'りゅう', 6: 'りゅう'},
        phrase: {
            default: 'りゅう座は、ギリシア神話に出てくる黄金の実のなるリンゴの木を守る巨大なりゅうがモデルとなっています。',
            1: 'りゅうざは、ギリシアしんわに出てくるおう金のみのなるリンゴの木をまもるきょだいなりゅうがモデルとなっています。',
            2: 'りゅうざは、ギリシアしん話に出てくる黄金のみのなるリンゴの木をまもるきょだいなりゅうがモデルとなっています。',
            3: 'りゅうざは、ギリシア神話に出てくる黄金の実のなるリンゴの木を守るきょだいなりゅうがモデルとなっています。',
            4: 'りゅうざは、ギリシア神話に出てくる黄金の実のなるリンゴの木を守る巨大（きょだい）なりゅうがモデルとなっています。',
            5: 'りゅうざは、ギリシア神話に出てくる黄金の実のなるリンゴの木を守る巨大（きょだい）なりゅうがモデルとなっています。',
            6: 'りゅう座は、ギリシア神話に出てくる黄金の実のなるリンゴの木を守る巨大（きょだい）なりゅうがモデルとなっています。',
        }
    },
    {code: 50, category: 1,
        label: { default: 'りゅうこつ', 1: 'りゅうこつ', 2: 'りゅうこつ', 3: 'りゅうこつ', 4: 'りゅうこつ', 5: 'りゅうこつ', 6: 'りゅうこつ'},
        phrase: {
            default: '「竜骨（りゅうこつ）」は船の底で船首から船尾をつなぐ骨組みの部品のことで、神話に登場する大きな船の骨組みの形を星座にしたものです。元はアルゴ座という大きな船の形をした星座の一部で、近世になって大きすぎるという理由で4つに分割されたうちのひとつです。',
            1: '「竜骨（りゅうこつ）」はふねのそこで せんしゅから船尾（せんび）をつなぐほねぐみのぶひんのことで、しんわにとうじょうする 大きなふねのほねぐみのかたちをせいざにしたものです。もとはアルゴざという大きなふねのかたちをしたせいざの一ぶで、きんせいになって大きすぎるというりゆうで4つにぶんかつされたうちのひとつです。',
            2: '「竜骨（りゅうこつ）」は船のそこで船首から船尾（せんび）をつなぐほね組みのぶひんのことで、しん話にとう場する大きな船のほね組みの形を星ざにしたものです。元はアルゴざという大きな船の形をしたせ星ざのいちぶで、近せいになって大きすぎるという理由（りゆう）で4つに分割（ぶんかつ）されたうちのひとつです。',
            3: '「竜骨（りゅうこつ）」は船のそこで船首から船尾（せんび）をつなぐほね組みの部品のことで、神話に登場する大きな船のほね組みの形を星ざにしたものです。元はアルゴざという大きな船の形をした星ざの一部で、近世になって大きすぎるという理由で4つに分割（ぶんかつ）されたうちのひとつです。',
            4: '「竜骨（りゅうこつ）」は船の底で船首から船尾（せんび）をつなぐほね組みの部品のことで、神話に登場する大きな船のほね組みの形を星ざにしたものです。元はアルゴざという大きな船の形をした星ざの一部で、近世になって大きすぎるという理由で4つに分割（ぶんかつ）されたうちのひとつです。',
            5: '「竜骨（りゅうこつ）」は船の底で船首から船尾（せんび）をつなぐほね組みの部品のことで、神話に登場する大きな船のほね組みの形を星ざにしたものです。元はアルゴざという大きな船の形をした星ざの一部で、近世になって大きすぎるという理由で4つに分割（ぶんかつ）されたうちのひとつです。',
            6: '「竜骨（りゅうこつ）」は船の底で船首から船尾（せんび）をつなぐ骨組みの部品のことで、神話に登場する大きな船の骨組みの形を星座にしたものです。元はアルゴ座という大きな船の形をした星座の一部で、近世になって大きすぎるという理由で4つに分割されたうちのひとつです。',
        }
    },
    {code: 51, category: 1,
        label: { default: 'ろ', 1: 'ろ', 2: 'ろ', 3: 'ろ', 4: 'ろ', 5: 'ろ', 6: 'ろ'},
        phrase: {
            default: '「ろ」とは「炉」のことで、フラスコを熱するための炉を表した星座です。18世紀半ばに設定された新しい星座です。',
            1: '「ろ」とは「炉（ろ）」のことで、フラスコをねっするための炉（ろ）をあらわしたせいざです。18せいきなかばに せっていされた あたらしいせいざです。',
            2: '「ろ」とは「炉（ろ）」のことで、フラスコをねっするための炉（ろ）をあらわした星ざです。18せいき半ばにせっていされた新しい星ざです。',
            3: '「ろ」とは「炉（ろ）」のことで、フラスコをねっするための炉（ろ）を表した星ざです。18世き半ばに設定（せってい）された新しい星ざです。',
            4: '「ろ」とは「炉（ろ）」のことで、フラスコを熱するための炉（ろ）を表した星ざです。18世紀半ばに設定（せってい）された新しい星ざです。',
            5: '「ろ」とは「炉（ろ）」のことで、フラスコを熱するための炉（ろ）を表した星ざです。18世紀半ばに設定された新しい星ざです。',
            6: '「ろ」とは「炉（ろ）」のことで、フラスコを熱するための炉（ろ）を表した星座です。18世紀半ばに設定された新しい星座です。',
        }
    },
    {code: 52, category: 1,
        label: { default: 'わし', 1: 'わし', 2: 'わし', 3: 'わし', 4: 'わし', 5: 'わし', 6: 'わし'},
        phrase: {
            default: 'わし座は、大神ゼウスがトロイアの王子であった美少年ガニュメーデスをさらうときに変身したわしの姿であるとされています。ガニュメーデスはみずがめ座の水がめをかつぐ少年のモデルになっています。',
            1: 'わしざは、大かみゼウスがトロイアの王子であった びしょうねんガニュメーデスをさらうときに へんしんしたわしのすがたであるとされています。ガニュメーデスはみずがめざの水がめをかつぐしょう年のモデルになっています。',
            2: 'わしざは、大かみゼウスがトロイアの王子であったび少年ガニュメーデスをさらうときにへんしんしたわしのすがたであるとされています。ガニュメーデスはみずがめざの水がめをかつぐ少年のモデルになっています。',
            3: 'わしざは、大神ゼウスがトロイアの王子であった美少年ガニュメーデスをさらうときにへん身したわしのすがたであるとされています。ガニュメーデスはみずがめざの水がめをかつぐ少年のモデルになっています。',
            4: 'わしざは、大神ゼウスがトロイアの王子であった美少年ガニュメーデスをさらうときに変身したわしのすがたであるとされています。ガニュメーデスはみずがめざの水がめをかつぐ少年のモデルになっています。',
            5: 'わしざは、大神ゼウスがトロイアの王子であった美少年ガニュメーデスをさらうときに変身したわしのすがたであるとされています。ガニュメーデスはみずがめざの水がめをかつぐ少年のモデルになっています。',
            6: 'わし座は、大神ゼウスがトロイアの王子であった美少年ガニュメーデスをさらうときに変身したわしの姿であるとされています。ガニュメーデスははみずがめ座の水がめをかつぐ少年のモデルになっています。',
        }
    },
    {code: 101, category: 2,
        label: { default: 'アクルックス', 1: 'アクルックス', 2: 'アクルックス', 3: 'アクルックス', 4: 'アクルックス', 5: 'アクルックス', 6: 'アクルックス'},
        phrase: {
            default: 'アクルックスはみなみじゅうじ座の星の一つです。アクルックスという名前は、α（アルフア）のアとみなみじゅうじ座の学名「クルックス」を組み合わせたものです。',
            1: 'アクルックスはみなみじゅうじざのほしの一つです。アクルックスという名まえは、α（アルフア）のアとみなみじゅうじざの学名「クルックス」をくみあわせたものです。',
            2: 'アクルックスはみなみじゅうじざの星の一つです。アクルックスという名前は、α（アルフア）のアとみなみじゅうじざの学名「クルックス」を組み合わせたものです。',
            3: 'アクルックスはみなみじゅうじざの星の一つです。アクルックスという名前は、α（アルフア）のアとみなみじゅうじざの学名「クルックス」を組み合わせたものです。',
            4: 'アクルックスはみなみじゅうじざの星の一つです。アクルックスという名前は、α（アルフア）のアとみなみじゅうじざの学名「クルックス」を組み合わせたものです。',
            5: 'アクルックスはみなみじゅうじざの星の一つです。アクルックスという名前は、α（アルフア）のアとみなみじゅうじざの学名「クルックス」を組み合わせたものです。',
            6: 'アクルックスはみなみじゅうじ座の星の一つです。アクルックスという名前は、α（アルフア）のアとみなみじゅうじ座の学名「クルックス」を組み合わせたものです。',
        }
    },
    {code: 102, category: 2,
        label: { default: 'アケルナル', 1: 'アケルナル', 2: 'アケルナル', 3: 'アケルナル', 4: 'アケルナル', 5: 'アケルナル', 6: 'アケルナル'},
        phrase: {
            default: 'アケルナルはエリダヌス座の星の一つです。アケルナルはアラビア語で「川の果て」という意味があります。',
            1: 'アケルナルはエリダヌスざのほしの一つです。アケルナルはアラビアごで「川のはて」といういみがあります。',
            2: 'アケルナルはエリダヌスざの星の一つです。アケルナルはアラビア語で「川のはて」といういみがあります。',
            3: 'アケルナルはエリダヌスざの星の一つです。アケルナルはアラビア語で「川のはて」という意味があります。',
            4: 'アケルナルはエリダヌスざの星の一つです。アケルナルはアラビア語で「川の果て」という意味があります。',
            5: 'アケルナルはエリダヌスざの星の一つです。アケルナルはアラビア語で「川の果て」という意味があります。',
            6: 'アケルナルはエリダヌス座の星の一つです。アケルナルはアラビア語で「川の果て」という意味があります。',
        }
    },
    {code: 103, category: 2,
        label: { default: 'アルクトゥルス', 1: 'アルクトゥルス', 2: 'アルクトゥルス', 3: 'アルクトゥルス', 4: 'アルクトゥルス', 5: 'アルクトゥルス', 6: 'アルクトゥルス'},
        phrase: {
            default: 'アルクトゥルスはうしかい座の星の一つです。アルクトゥルスはギリシア語で「クマの番人」という意味があります。',
            1: 'アルクトゥルスはうしかいざのほしの一つです。アルクトゥルスはギリシアごで「クマのばん人」といういみがあります。',
            2: 'アルクトゥルスはうしかいざの星の一つです。アルクトゥルスはギリシア語で「クマの番人」といういみがあります。',
            3: 'アルクトゥルスはうしかいざの星の一つです。アルクトゥルスはギリシア語で「クマの番人」という意味があります。',
            4: 'アルクトゥルスはうしかいざの星の一つです。アルクトゥルスはギリシア語で「クマの番人」という意味があります。',
            5: 'アルクトゥルスはうしかいざの星の一つです。アルクトゥルスはギリシア語で「クマの番人」という意味があります。',
            6: 'アルクトゥルスはうしかい座の星の一つです。アルクトゥルスはギリシア語で「クマの番人」という意味があります。',
        }
    },
    {code: 104, category: 2,
        label: { default: 'アルタイル', 1: 'アルタイル', 2: 'アルタイル', 3: 'アルタイル', 4: 'アルタイル', 5: 'アルタイル', 6: 'アルタイル'},
        phrase: {
            default: 'アルタイルはわし座の星の一つで、七夕の彦星としても有名です。アルタイルはアラビア語で「飛ぶワシ」という意味があります。',
            1: 'アルタイルはわしざのほしの一つで、七夕のひこぼしとしてもゆうめいです。アルタイルはアラビアごで「とぶワシ」といういみがあります。',
            2: 'アルタイルはわしざの星の一つで、七夕のひこ星としてもゆうめいです。アルタイルはアラビア語で「とぶワシ」といういみがあります。',
            3: 'アルタイルはわしざの星の一つで、七夕のひこ星としても有名です。アルタイルはアラビア語で「とぶワシ」という意味があります。',
            4: 'アルタイルはわしざの星の一つで、七夕のひこ星としても有名です。アルタイルはアラビア語で「飛ぶワシ」という意味があります。',
            5: 'アルタイルはわしざの星の一つで、七夕のひこ星としても有名です。アルタイルはアラビア語で「飛ぶワシ」という意味があります。',
            6: 'アルタイルはわし座の星の一つで、七夕のひこ星としても有名です。アルタイルはアラビア語で「飛ぶワシ」という意味があります。',
        }
    },
    {code: 105, category: 2,
        label: { default: 'アルデバラン', 1: 'アルデバラン', 2: 'アルデバラン', 3: 'アルデバラン', 4: 'アルデバラン', 5: 'アルデバラン', 6: 'アルデバラン'},
        phrase: {
            default: 'アルデバランはおうし座の星の一つです。アルデバランはアラビア語で「後に従うもの」という意味で、これはプレアデス星団の後に上ってくることから名づけられました。',
            1: 'アルデバランはおうしざのほしの一つです。アルデバランはアラビアごで「のちにしたがうもの」といういみで、これはプレアデスせいだんののちに上ってくることから名づけられました。',
            2: 'アルデバランはおうしざの星の一つです。アルデバランはアラビア語で「後にしたがうもの」といういみで、これはプレアデス星だんの後に上ってくることから名づけられました。',
            3: 'アルデバランはおうしざの星の一つです。アルデバランはアラビア語で「後にしたがうもの」という意味で、これはプレアデス星だんの後に上ってくることから名づけられました。',
            4: 'アルデバランはおうしざの星の一つです。アルデバランはアラビア語で「後にしたがうもの」という意味で、これはプレアデス星だんの後に上ってくることから名づけられました。',
            5: 'アルデバランはおうしざの星の一つです。アルデバランはアラビア語で「後にしたがうもの」という意味で、これはプレアデス星団の後に上ってくることから名づけられました。',
            6: 'アルデバランはおうし座の星の一つです。アルデバランはアラビア語で「後に従うもの」という意味で、これはプレアデス星団の後に上ってくることから名づけられました。',
        }
    },
    {code: 106, category: 2,
        label: { default: 'アンタレス', 1: 'アンタレス', 2: 'アンタレス', 3: 'アンタレス', 4: 'アンタレス', 5: 'アンタレス', 6: 'アンタレス'},
        phrase: {
            default: 'アンタレスはさそり座の星の一つです。アンタレスはギリシア語で「火星に対抗するもの」という意味があります。',
            1: 'アンタレスはさそりざのほしの一つです。アンタレスはギリシアごで「かせいにたいこうするもの」といういみがあります。',
            2: 'アンタレスはさそりざの星の一つです。アンタレスはギリシア語で「火星にたいこうするもの」といういみがあります。',
            3: 'アンタレスはさそりざの星の一つです。アンタレスはギリシア語で「火星に対こうするもの」という意味があります。',
            4: 'アンタレスはさそりざの星の一つです。アンタレスはギリシア語で「火星に対こうするもの」という意味があります。',
            5: 'アンタレスはさそりざの星の一つです。アンタレスはギリシア語で「火星に対こうするもの」という意味があります。',
            6: 'アンタレスはさそり座の星の一つです。アンタレスはギリシア語で「火星に対こうするもの」という意味があります。',
        }
    },
    {code: 107, category: 2,
        label: { default: 'カノープス', 1: 'カノープス', 2: 'カノープス', 3: 'カノープス', 4: 'カノープス', 5: 'カノープス', 6: 'カノープス'},
        phrase: {
            default: 'カノープスはりゅうこつ座の星の一つです。カノープスはトロイ戦争でギリシア艦隊の船乗りの名前に由来するという説があります。',
            1: 'カノープスはりゅうこつざのほしの一つです。カノープスはトロイせんそうで ギリシアかんたいのふなのりの名まえにゆらいするというせつがあります。',
            2: 'カノープスはりゅうこつざの星の一つです。カノープスはトロイせんそうでギリシアかんたいの船のりの名前に由来（ゆらい）するというせつがあります。',
            3: 'カノープスはりゅうこつざの星の一つです。カノープスはトロイせんそうでギリシアかんたいの船乗りの名前に由来するというせつがあります。',
            4: 'カノープスはりゅうこつざの星の一つです。カノープスはトロイ戦争でギリシアかん隊の船乗りの名前に由来するという説があります。',
            5: 'カノープスはりゅうこつざの星の一つです。カノープスはトロイ戦争でギリシアかん隊の船乗りの名前に由来するという説があります。',
            6: 'カノープスはりゅうこつ座の星の一つです。カノープスはトロイ戦争でギリシアかん隊の船乗りの名前に由来するという説があります。',
        }
    },
    {code: 108, category: 2,
        label: { default: 'カペラ', 1: 'カペラ', 2: 'カペラ', 3: 'カペラ', 4: 'カペラ', 5: 'カペラ', 6: 'カペラ'},
        phrase: {
            default: 'カペラはぎょしゃ座の星の一つです。カペラはラテン語で「メスの子ヤギ」という意味で、ぎょしゃ座の男が抱えるヤギにあたる部分にある星です。',
            1: 'カペラはぎょしゃざのほしの一つです。カペラはラテンごで「メスの子ヤギ」といういみで、ぎょしゃざの男がかかえるヤギにあたるぶぶんにあるほしです。',
            2: 'カペラはぎょしゃざの星の一つです。カペラはラテン語で「メスの子ヤギ」といういみで、ぎょしゃざの男がかかえるヤギにあたる部分（ぶぶん）にある星です。',
            3: 'カペラはぎょしゃざの星の一つです。カペラはラテン語で「メスの子ヤギ」という意味で、ぎょしゃざの男がかかえるヤギにあたる部分にある星です。',
            4: 'カペラはぎょしゃざの星の一つです。カペラはラテン語で「メスの子ヤギ」という意味で、ぎょしゃざの男がかかえるヤギにあたる部分にある星です。',
            5: 'カペラはぎょしゃざの星の一つです。カペラはラテン語で「メスの子ヤギ」という意味で、ぎょしゃざの男がかかえるヤギにあたる部分にある星です。',
            6: 'カペラはぎょしゃ座の星の一つです。カペラはラテン語で「メスの子ヤギ」という意味で、ぎょしゃ座の男がかかえるヤギにあたる部分にある星です。',
        }
    },
    {code: 109, category: 2,
        label: { default: 'シリウス', 1: 'シリウス', 2: 'シリウス', 3: 'シリウス', 4: 'シリウス', 5: 'シリウス', 6: 'シリウス'},
        phrase: {
            default: 'シリウスはおおいいぬ座の星の一つです。シリウスはギリシア語で「光り輝くもの」「焼き焦がすもの」という意味で、その名の通り夜空に見える中で一番明るい恒星です。',
            1: 'シリウスはおおいいぬざのほしの一つです。シリウスはギリシアごで「ひかりかがやくもの」「やきこがすもの」といういみで、その名のとおりよ空に見える中で 一ばんあかるいこうせいです。',
            2: 'シリウスはおおいいぬざの星の一つです。シリウスはギリシア語で「光りかがやくもの」「やきこがすもの」といういみで、その名の通り夜空に見える中で一番明るいこう星です。',
            3: 'シリウスはおおいいぬざの星の一つです。シリウスはギリシア語で「光りかがやくもの」「やきこがすもの」という意味で、その名の通り夜空に見える中で一番明るいこう星です。',
            4: 'シリウスはおおいいぬざの星の一つです。シリウスはギリシア語で「光りかがやくもの」「焼きこがすもの」という意味で、その名の通り夜空に見える中で一番明るいこう星です。',
            5: 'シリウスはおおいいぬざの星の一つです。シリウスはギリシア語で「光りかがやくもの」「焼きこがすもの」という意味で、その名の通り夜空に見える中で一番明るいこう星です。',
            6: 'シリウスはおおいいぬ座の星の一つです。シリウスはギリシア語で「光りかがやくもの」「焼きこがすもの」という意味で、その名の通り夜空に見える中で一番明るいこう星です。',
        }
    },
    {code: 110, category: 2,
        label: { default: 'スピカ', 1: 'スピカ', 2: 'スピカ', 3: 'スピカ', 4: 'スピカ', 5: 'スピカ', 6: 'スピカ'},
        phrase: {
            default: 'スピカはおとめ座の星の一つです。スピカはギリシア語で「穂先」という意味で、おとめ座の女神が握る麦の穂先にあたる部分にある星です。',
            1: 'スピカはおとめざのほしの一つです。スピカはギリシアごで「ほ先」といういみで、おとめざのめがみがにぎる むぎのほ先にあたるぶぶんにあるほしです。',
            2: 'スピカはおとめざの星の一つです。スピカはギリシア語で「ほ先」といういみで、おとめざのめがみがにぎる麦のほ先にあたる部分（ぶぶん）にある星です。',
            3: 'スピカはおとめざの星の一つです。スピカはギリシア語で「ほ先」という意味で、おとめざの女神がにぎる麦のほ先にあたる部分にある星です。',
            4: 'スピカはおとめざの星の一つです。スピカはギリシア語で「ほ先」という意味で、おとめざの女神がにぎる麦のほ先にあたる部分にある星です。',
            5: 'スピカはおとめざの星の一つです。スピカはギリシア語で「ほ先」という意味で、おとめざの女神がにぎる麦のほ先にあたる部分にある星です。',
            6: 'スピカはおとめ座の星の一つです。スピカはギリシア語で「ほ先」という意味で、おとめ座の女神がにぎる麦のほ先にあたる部分にある星です。',
        }
    },
    {code: 111, category: 2,
        label: { default: 'デネブ', 1: 'デネブ', 2: 'デネブ', 3: 'デネブ', 4: 'デネブ', 5: 'デネブ', 6: 'デネブ'},
        phrase: {
            default: 'デネブははくちょう座の星の一つです。デネブはアラビア語で「めんどりの尾」という意味で、はくちょう座の尾の部分にあたります。',
            1: 'デネブははくちょうざのほしの一つです。デネブはアラビアごで「めんどりのお」 といういみで、はくちょうざのおのぶぶんにあたります。',
            2: 'デネブははくちょうざの星の一つです。デネブはアラビア語で「めんどりのお」といういみで、はくちょうざのおの部分（ぶぶん）にあたります。',
            3: 'デネブははくちょうざの星の一つです。デネブはアラビア語で「めんどりのお」という意味で、はくちょうざのおの部分にあたります。',
            4: 'デネブははくちょうざの星の一つです。デネブはアラビア語で「めんどりのお」という意味で、はくちょうざのおの部分にあたります。',
            5: 'デネブははくちょうざの星の一つです。デネブはアラビア語で「めんどりのお」という意味で、はくちょうざの尾（お）の部分にあたります。',
            6: 'デネブははくちょう座の星の一つです。デネブはアラビア語で「めんどりのお」という意味で、はくちょう座の尾（お）の部分にあたります。',
        }
    },
    {code: 112, category: 2,
        label: { default: 'ハダル', 1: 'ハダル', 2: 'ハダル', 3: 'ハダル', 4: 'ハダル', 5: 'ハダル', 6: 'ハダル'},
        phrase: {
            default: 'ハダルはケンタウルス座の星の一つです。ハダルはアラビア語で「地面」という意味があります。',
            1: 'ハダルはケンタウルスざのほしの一つです。ハダルはアラビアごで「じめん」とい ういみがあります。',
            2: 'ハダルはケンタウルスざの星の一つです。ハダルはアラビア語で「地めん」といういみがあります。',
            3: 'ハダルはケンタウルスざの星の一つです。ハダルはアラビア語で「地面」という意味があります。',
            4: 'ハダルはケンタウルスざの星の一つです。ハダルはアラビア語で「地面」という意味があります。',
            5: 'ハダルはケンタウルスざの星の一つです。ハダルはアラビア語で「地面」という意味があります。',
            6: 'ハダルはケンタウルス座の星の一つです。ハダルはアラビア語で「地面」という意味があります。',
        }
    },
    {code: 113, category: 2,
        label: { default: 'フォーマルハウト', 1: 'フォーマルハウト', 2: 'フォーマルハウト', 3: 'フォーマルハウト', 4: 'フォーマルハウト', 5: 'フォーマルハウト', 6: 'フォーマルハウト'},
        phrase: {
            default: 'フォーマルハウトはみなみのうお座の星の一つです。フォーマルハウトはアラビア語で「魚の口」という意味で、みなみのうお座の魚の口部分にあたります。',
            1: 'フォーマルハウトはみなみのうおざのほしの一つです。フォーマルハウトはアラビアごで「さかなの口」といういみで、みなみのうおざの さかなの口ぶぶんにあたります。',
            2: 'フォーマルハウトはみなみのうおざの星の一つです。フォーマルハウトはアラビア語で「魚の口」といういみで、みなみのうおざの魚の口部分（ぶぶん）にあたります。',
            3: 'フォーマルハウトはみなみのうおざの星の一つです。フォーマルハウトはアラビア語で「魚の口」という意味で、みなみのうおざの魚の口部分にあたります。',
            4: 'フォーマルハウトはみなみのうおざの星の一つです。フォーマルハウトはアラビア語で「魚の口」という意味で、みなみのうおざの魚の口部分にあたります。',
            5: 'フォーマルハウトはみなみのうおざの星の一つです。フォーマルハウトはアラビア語で「魚の口」という意味で、みなみのうおざの魚の口部分にあたります。',
            6: 'フォーマルハウトはみなみのうお座の星の一つです。フォーマルハウトはアラビア語で「魚の口」という意味で、みなみのうお座の魚の口部分にあたります。',
        }
    },
    {code: 114, category: 2,
        label: { default: 'プレヤデス星団（すばる）', 1: 'プレヤデスせいだん（すばる）', 2: 'プレヤデス星だん（すばる）', 3: 'プレヤデス星だん（すばる）', 4: 'プレヤデス星だん（すばる）', 5: 'プレヤデス星団（すばる）', 6: 'プレヤデス星団（すばる）'},
        phrase: {
            default: 'プレアデス星団はおうし座の散開星団（数十から数百個の恒星の集まり）です。ギリシア神話に登場する七人姉妹の女神たちにちなんで名づけられました。日本ではすばるという名前で知られており、「まとまって1つになる」という意味の「統ばる（すばる）」からきています。',
            1: 'プレアデスせいだんは おうしざのさんかいせいだん（すう十からすう百このこうせいのあつまり）です。ギリシアしんわにとうじょうする七人しまいのめが みたちにちなんで名づけられました。日本ではすばるという名まえでしられており、「まとまって1つになる」といういみの「統ばる（すばる）」からきています。',
            2: 'プレアデス星だんはおうしざのさんかい星だん（数十から数百このこう星のあつまり）です。ギリシアしん話にとう場する七人姉妹のめがみたちにちなんで名づけられました。日本ではすばるという名前で知られており、「まとまって1つになる」といういみの「統ばる（すばる）」からきています。',
            3: 'プレアデス星だんはおうしざのさん開星だん（数十から数百このこう星の集まり）です。ギリシア神話に登場する七人姉妹の女神たちにちなんで名づけられました。日本ではすばるという名前で知られており、「まとまって1つになる」という意味の「統ばる（すばる）」からきています。',
            4: 'プレアデス星だんはおうしざの散開星団（数十から数百このこう星の集まり）です。ギリシア神話に登場する七人姉妹の女神たちにちなんで名づけられました。日本ではすばるという名前で知られており、「まとまって1つになる」という意味の「統ばる（すばる）」からきています。',
            5: 'プレアデス星団はおうしざの散開星団（数十から数百個のこう星の集まり）です。ギリシア神話に登場する七人姉妹の女神たちにちなんで名づけられました。日本ではすばるという名前で知られており、「まとまって1つになる」という意味の「統ばる（すばる）」からきています。',
            6: 'プレアデス星団はおうし座の散開星団（数十から数百個のこう星の集まり）です。ギリシア神話に登場する七人姉妹の女神たちにちなんで名づけられました。日本ではすばるという名前で知られており、「まとまって1つになる」という意味の「統ばる（すばる）」からきています。',
        }
    },
    {code: 115, category: 2,
        label: { default: 'プロキオン', 1: 'プロキオン', 2: 'プロキオン', 3: 'プロキオン', 4: 'プロキオン', 5: 'プロキオン', 6: 'プロキオン'},
        phrase: {
            default: 'プロキオンはこいぬ座の星の一つです。プロキオンはギリシア語で「犬の前に」という意味で、おおいぬ座のシリウスより先に上ってくることからつけられたといいます。',
            1: 'プロキオンはこいぬざのほしの一つです。プロキオンはギリシアごで「犬のまえに」といういみで、おおいぬざのシリウスより先に上ってくることからつけられたといいます。',
            2: 'プロキオンはこいぬざの星の一つです。プロキオンはギリシア語で「犬の前に」といういみで、おおいぬざのシリウスより先に上ってくることからつけられたといいます。',
            3: 'プロキオンはこいぬざの星の一つです。プロキオンはギリシア語で「犬の前に」という意味で、おおいぬざのシリウスより先に上ってくることからつけられたといいます。',
            4: 'プロキオンはこいぬざの星の一つです。プロキオンはギリシア語で「犬の前に」という意味で、おおいぬざのシリウスより先に上ってくることからつけられたといいます。',
            5: 'プロキオンはこいぬざの星の一つです。プロキオンはギリシア語で「犬の前に」という意味で、おおいぬざのシリウスより先に上ってくることからつけられたといいます。',
            6: 'プロキオンはこいぬ座の星の一つです。プロキオンはギリシア語で「犬の前に」という意味で、おおいぬ座のシリウスより先に上ってくることからつけられたといいます。',
        }
    },
    {code: 116, category: 2,
        label: { default: 'ベガ', 1: 'ベガ', 2: 'ベガ', 3: 'ベガ', 4: 'ベガ', 5: 'ベガ', 6: 'ベガ'},
        phrase: {
            default: 'ベガはこと座の星の一つで、七夕の織姫の星としても有名です。ベガはアラビア語で「落ちるワシ」という意味があります。',
            1: 'ベガはことざのほしの一つで、七夕のおりひめのほしとしてもゆうめいです。ベガはアラビアごで「おちるワシ」といういみがあります。',
            2: 'ベガはことざの星の一つで、七夕のおりひめの星としてもゆうめいです。ベガはアラビア語で「おちるワシ」といういみがあります。',
            3: 'ベガはことざの星の一つで、七夕のおりひめの星としても有名です。ベガはアラビア語で「落ちるワシ」という意味があります。',
            4: 'ベガはことざの星の一つで、七夕のおりひめの星としても有名です。ベガはアラビア語で「落ちるワシ」という意味があります。',
            5: 'ベガはことざの星の一つで、七夕の織姫（おりひめ）の星としても有名です。ベガはアラビア語で「落ちるワシ」という意味があります。',
            6: 'ベガはこと座の星の一つで、七夕の織姫（おりひめ）の星としても有名です。ベガはアラビア語で「落ちるワシ」という意味があります。',
        }
    },
    {code: 117, category: 2,
        label: { default: 'ベクルックス', 1: 'ベクルックス', 2: 'ベクルックス', 3: 'ベクルックス', 4: 'ベクルックス', 5: 'ベクルックス', 6: 'ベクルックス'},
        phrase: {
            default: 'ベクルックスはみなみじゅうじ座の星の一つです。ベクルックスという名前は、β（ベータ）のベとみなみじゅうじ座の学名「クルックス」を組み合わせたものです。',
            1: 'ベクルックスはみなみじゅうじざのほしの一つです。ベクルックスという名まえは、β（ベータ）のベとみなみじゅうじざの学名「クルックス」をくみあわせたものです。',
            2: 'ベクルックスはみなみじゅうじざの星の一つです。ベクルックスという名前は、β（ベータ）のベとみなみじゅうじざの学名「クルックス」を組み合わせたものです。',
            3: 'ベクルックスはみなみじゅうじざの星の一つです。ベクルックスという名前は、β（ベータ）のベとみなみじゅうじざの学名「クルックス」を組み合わせたものです。',
            4: 'ベクルックスはみなみじゅうじざの星の一つです。ベクルックスという名前は、β（ベータ）のベとみなみじゅうじざの学名「クルックス」を組み合わせたものです。',
            5: 'ベクルックスはみなみじゅうじざの星の一つです。ベクルックスという名前は、β（ベータ）のベとみなみじゅうじざの学名「クルックス」を組み合わせたものです。',
            6: 'ベクルックスはみなみじゅうじ座の星の一つです。ベクルックスという名前は、β（ベータ）のベとみなみじゅうじ座の学名「クルックス」を組み合わせたものです。',
        }
    },
    {code: 118, category: 2,
        label: { default: 'ベテルギウス', 1: 'ベテルギウス', 2: 'ベテルギウス', 3: 'ベテルギウス', 4: 'ベテルギウス', 5: 'ベテルギウス', 6: 'ベテルギウス'},
        phrase: {
            default: 'ベテルギウスはオリオン座の星の一つです。ベテルギウスはアラビア語で「巨人の肩」という意味で、オリオン座の右肩部分にあたります。',
            1: 'ベテルギウスはオリオンざのほしの一つです。ベテルギウスはアラビアごで「きょ人のかた」といういみで、オリオンざの右かたぶぶんにあたります',
            2: 'ベテルギウスはオリオンざの星の一つです。ベテルギウスはアラビア語で「きょ人のかた」といういみで、オリオンざの右かた部分（ぶぶん）にあたります。',
            3: 'ベテルギウスはオリオンざの星の一つです。ベテルギウスはアラビア語で「きょ人のかた」という意味で、オリオンざの右かた部分にあたります。',
            4: 'ベテルギウスはオリオンざの星の一つです。ベテルギウスはアラビア語で「きょ人のかた」という意味で、オリオンざの右かた部分にあたります。',
            5: 'ベテルギウスはオリオンざの星の一つです。ベテルギウスはアラビア語で「きょ人のかた」という意味で、オリオンざの右かた部分にあたります。',
            6: 'ベテルギウスはオリオン座の星の一つです。ベテルギウスはアラビア語で「きょ人のかた」という意味で、オリオン座の右かた部分にあたります。',
        }
    },
    {code: 119, category: 2,
        label: { default: 'ポルックス', 1: 'ポルックス', 2: 'ポルックス', 3: 'ポルックス', 4: 'ポルックス', 5: 'ポルックス', 6: 'ポルックス'},
        phrase: {
            default: 'ポルックスはふたご座の星の一つです。ポルックスはギリシア神話に登場する双子の英雄の弟ポリュデウケスの名に由来するといいます。',
            1: 'ポルックスはふたござのほしの一つです。ポルックスはギリシアしんわにとうじょうする ふたごのえいゆうのおとうとポリュデウケスの名にゆらいするといいます。',
            2: 'ポルックスはふたござの星の一つです。ポルックスはギリシアしん話にとう場するふたごのえいゆうの弟ポリュデウケスの名に由来（ゆらい）するといいます。',
            3: 'ポルックスはふたござの星の一つです。ポルックスはギリシア神話に登場するふたごのえいゆうの弟ポリュデウケスの名に由来するといいます。',
            4: 'ポルックスはふたござの星の一つです。ポルックスはギリシア神話に登場するふた子の英ゆうの弟ポリュデウケスの名に由来するといいます。',
            5: 'ポルックスはふたござの星の一つです。ポルックスはギリシア神話に登場するふた子の英ゆうの弟ポリュデウケスの名に由来するといいます。',
            6: 'ポルックスはふたご座の星の一つです。ポルックスはギリシア神話に登場するふた子の英ゆうの弟ポリュデウケスの名に由来するといいます。',
        }
    },
    {code: 120, category: 2,
        label: { default: 'リギル・ケンタウルス', 1: 'リギル・ケンタウルス', 2: 'リギル・ケンタウルス', 3: 'リギル・ケンタウルス', 4: 'リギル・ケンタウルス', 5: 'リギル・ケンタウルス', 6: 'リギル・ケンタウルス'},
        phrase: {
            default: 'リギル・ケンタウルスはケンタウルス座の星の一つです。リギル・ケンタウルスはアラビア語で「ケンタウルスの足」という意味があります。',
            1: 'リギル・ケンタウルスはケンタウルスざのほしの一つです。リギル・ケンタウルスはアラビアごで「ケンタウルスの足」といういみがあります。',
            2: 'リギル・ケンタウルスはケンタウルスざの星の一つです。リギル・ケンタウルスはアラビア語で「ケンタウルスの足」といういみがあります。',
            3: 'リギル・ケンタウルスはケンタウルスざの星の一つです。リギル・ケンタウルスはアラビア語で「ケンタウルスの足」という意味があります。',
            4: 'リギル・ケンタウルスはケンタウルスざの星の一つです。リギル・ケンタウルスはアラビア語で「ケンタウルスの足」という意味があります。',
            5: 'リギル・ケンタウルスはケンタウルスざの星の一つです。リギル・ケンタウルスはアラビア語で「ケンタウルスの足」という意味があります。',
            6: 'リギル・ケンタウルスはケンタウルス座の星の一つです。リギル・ケンタウルスはアラビア語で「ケンタウルスの足」という意味があります。',
        }
    },
    {code: 121, category: 2,
        label: { default: 'リゲル', 1: 'リゲル', 2: 'リゲル', 3: 'リゲル', 4: 'リゲル', 5: 'リゲル', 6: 'リゲル'},
        phrase: {
            default: 'リゲルはオリオン座の星の一つです。リゲルはアラビア語で「巨人の足」という意味で、オリオン座の右足部分にあたります。',
            1: 'リゲルはオリオンざのほしの一つです。リゲルはアラビアごで「きょ人の足」といういみで、オリオンざの右足ぶぶんにあたります。',
            2: 'リゲルはオリオンざの星の一つです。リゲルはアラビア語で「きょ人の足」といういみで、オリオンざの右足部分（ぶぶん）にあたります。',
            3: 'リゲルはオリオンざの星の一つです。リゲルはアラビア語で「きょ人の足」という意味で、オリオンざの右足部分にあたります。',
            4: 'リゲルはオリオンざの星の一つです。リゲルはアラビア語で「きょ人の足」という意味で、オリオンざの右足部分にあたります。',
            5: 'リゲルはオリオンざの星の一つです。リゲルはアラビア語で「きょ人の足」という意味で、オリオンざの右足部分にあたります。',
            6: 'リゲルはオリオン座の星の一つです。リゲルはアラビア語で「きょ人の足」という意味で、オリオン座の右足部分にあたります。',
        }
    },
    {code: 122, category: 2,
        label: { default: 'レグルス', 1: 'レグルス', 2: 'レグルス', 3: 'レグルス', 4: 'レグルス', 5: 'レグルス', 6: 'レグルス'},
        phrase: {
            default: 'レグルスはしし座の星の一つです。レグルスはラテン語で「小さな王」という意味があります。',
            1: 'レグルスはししざのほしの一つです。レグルスはラテンごで「小さな王」といういみがあります。',
            2: 'レグルスはししざの星の一つです。レグルスはラテン語で「小さな王」といういみがあります。',
            3: 'レグルスはししざの星の一つです。レグルスはラテン語で「小さな王」という意味があります。',
            4: 'レグルスはししざの星の一つです。レグルスはラテン語で「小さな王」という意味があります。',
            5: 'レグルスはししざの星の一つです。レグルスはラテン語で「小さな王」という意味があります。',
            6: 'レグルスはしし座の星の一つです。レグルスはラテン語で「小さな王」という意味があります。',
        }
    },
    {code: 123, category: 2,
        label: { default: '北極星', 1: 'ほっきょくせい', 2: '北きょく星', 3: '北きょく星', 4: '北極星', 5: '北極星', 6: '北極星'},
        phrase: {
            default: '北極星はこぐま座の星の一つで、ラテン語で「極の」を意味するポラリスという名前もあります。北の空で位置がほとんど変わらないため、北の方角の目印になる星として親しまれています。',
            1: 'ほっきょくせいは こぐまざのほしの一つで、ラテンごで「極の（きょくの）」をいみするポラリスという名まえもあります。きたの空でいちがほとんどかわらないため、きたのほうがくの目じるしになるほしとしてしたしまれています。',
            2: '北極星（ほっきょくせい）はこぐまざの星の一つで、ラテン語で「極の（きょくの）」をいみするポラリスという名前もあります。北の空でいちがほとんどかわらないため、北の方角の目じるしになる星として親しまれています。',
            3: '北極星（ほっきょくせい）はこぐまざの星の一つで、ラテン語で「極の（きょくの）」を意味するポラリスという名前もあります。北の空でいちがほとんどかわらないため、北の方角の目じるしになる星として親しまれています。',
            4: '北極星はこぐまざの星の一つで、ラテン語で「極の」を意味するポラリスという名前もあります。北の空で位置がほとんど変わらないため、北の方角の目印になる星として親しまれています。',
            5: '北極星はこぐまざの星の一つで、ラテン語で「極の」を意味するポラリスという名前もあります。北の空で位置がほとんど変わらないため、北の方角の目印になる星として親しまれています。',
            6: '北極星はこぐま座の星の一つで、ラテン語で「極の」を意味するポラリスという名前もあります。北の空で位置がほとんど変わらないため、北の方角の目印になる星として親しまれています。',
        }
    },
    {code: 124, category: 3,
        label: { default: '北斗七星', 1: 'ほくと七せい', 2: '北と七星', 3: '北と七星', 4: '北と七星', 5: '北と七星', 6: '北斗七星'},
        phrase: {
            default: '北斗七星はおおぐま座の一部で、背中からしっぽにあたる星の並びです。北斗七星の名前の由来は、北の空にある7つの星の並びが柄杓（ひしゃく）の形に見えることから、柄杓を表す「斗」を使って呼ばれるようになったといわれています。',
            1: '北斗（ほくと）七せいは おおぐまざのいちぶで、せなかからしっぽにあたるほしのならびです。ほくと七せいの名まえのゆらいは、きたの空にある7つのほしのならびが ひしゃくのかたちに見えることから、ひしゃくをあらわす「斗（と）」をつかってよばれるようになったといわれています。',
            2: '北斗（ほくと）七星はおおぐまざのいちぶで、せなかからしっぽにあたる星のならびです。ほくと七星の名前の由来（ゆらい）は、北の空にある7つの星のならびがひしゃくの形に見えることから、ひしゃくをあらわす「斗（と）」をつかってよばれるようになったといわれています。',
            3: '北斗（ほくと）七星はおおぐまざの一部で、せなかからしっぽにあたる星のならびです。ほくと七星の名前の由来は、北の空にある7つの星のならびがひしゃくの形に見えることから、ひしゃくを表す「斗（と）」を使ってよばれるようになったといわれています。',
            4: '北斗（ほくと）七星はおおぐまざの一部で、せ中からしっぽにあたる星のならびです。北斗（ほくと）七星の名前の由来は、北の空にある7つの星のならびがひしゃくの形に見えることから、ひしゃくを表す「斗（と）」を使ってよばれるようになったといわれています。',
            5: '北斗（ほくと）七星はおおぐまざの一部で、せ中からしっぽにあたる星のならびです。北斗（ほくと）七星の名前の由来は、北の空にある7つの星のならびがひしゃくの形に見えることから、ひしゃくを表す「斗（と）」を使って呼ばれるようになったといわれています。',
            6: '北斗（ほくと）七星はおおぐま座の一部で、背中からしっぽにあたる星の並びです。北斗（ほくと）七星の名前の由来は、北の空にある7つの星の並びがひしゃくの形に見えることから、ひしゃくを表す「斗（と）」を使って呼ばれるようになったといわれています。',
        }
    },
    {code: 201, category: 3,
        label: { default: '冬の大三角', 1: 'ふゆの大三かく', 2: '冬の大三角', 3: '冬の大三角', 4: '冬の大三角', 5: '冬の大三角', 6: '冬の大三角'},
        phrase: {
            default: '冬の南の空に見える、おおいぬ座の「シリウス」、こいぬ座の「プロキオン」、オリオン座の「ベテルギウス」の3つの星を結んでできる三角形です。',
            1: 'ふゆのみなみの空に見える、おおいぬざの「シリウス」、こいぬざの「プロキオン」、オリオンざの「ベテルギウス」の3つのほしをむすんでできる三かくけいです。',
            2: '冬の南の空に見える、おおいぬざの「シリウス」、こいぬざの「プロキオン」、オリオンざの「ベテルギウス」の3つの星をむすんでできる三角形です。',
            3: '冬の南の空に見える、おおいぬざの「シリウス」、こいぬざの「プロキオン」、オリオンざの「ベテルギウス」の3つの星をむすんでできる三角形です。',
            4: '冬の南の空に見える、おおいぬざの「シリウス」、こいぬざの「プロキオン」、オリオンざの「ベテルギウス」の3つの星を結んでできる三角形です。',
            5: '冬の南の空に見える、おおいぬざの「シリウス」、こいぬざの「プロキオン」、オリオンざの「ベテルギウス」の3つの星を結んでできる三角形です。',
            6: '冬の南の空に見える、おおいぬ座の「シリウス」、こいぬ座の「プロキオン」、オリオン座の「ベテルギウス」の3つの星を結んでできる三角形です。',
        }
    },
    {code: 202, category: 3,
        label: { default: '赤道', 1: '赤どう', 2: '赤道', 3: '赤道', 4: '赤道', 5: '赤道', 6: '赤道'},
        phrase: {
            default: '地球の赤道を宇宙まで延長した線が天球上に交わってできる大きい円のことです。',
            1: 'ちきゅうのせきどうを うちゅうまでえんちょうしたせんが てんきゅう上にまじわってできる大きい円のことです。',
            2: '地きゅうの赤道をうちゅうまでえん長した線がてんきゅう上に交わってできる大きい円のことです。',
            3: '地球の赤道をうちゅうまでえん長した線が天球上に交わってできる大きい円のことです。',
            4: '地球の赤道をうちゅうまでえん長した線が天球上に交わってできる大きい円のことです。',
            5: '地球の赤道をうちゅうまでえん長した線が天球上に交わってできる大きい円のことです。',
            6: '地球の赤道を宇宙まで延長した線が天球上に交わってできる大きい円のことです。',
        }
    },
    {code: 203, category: 3,
        label: { default: '春分点', 1: 'しゅんぶんてん', 2: '春分点', 3: '春分点', 4: '春分点', 5: '春分点', 6: '春分点'},
        phrase: {
            default: '黄道と、天の赤道（地球の赤道を宇宙まで延長した線のこと）が交わる点のことです。2つあり、それぞれを春分点、秋分点と呼んでいます。太陽が南から北に横切る点を春分点といいます。',
            1: 'こうどうと、天のせきどう （ちきゅうのせきどうを うちゅうまでえんちょうしたせんのこと） がまじわるてんのことです。2つあり、それぞれをしゅんぶんてん、しゅうぶんてんとよんでいます。たいようがみなみからきたによこぎるてんを しゅんぶんてんといいます。',
            2: '黄道と、天の赤道（地きゅうの赤道をうちゅうまでえん長した線のこと）が交わる点のことです。2つあり、それぞれを春分点、秋分点とよんでいます。太陽（たいよう）が南から北によこ切る点を春分点といいます。',
            3: '黄道と、天の赤道（地球の赤道をうちゅうまでえん長した線のこと）が交わる点のことです。2つあり、それぞれを春分点、秋分点とよんでいます。太陽が南から北に横切る点を春分点といいます。',
            4: '黄道と、天の赤道（地球の赤道をうちゅうまでえん長した線のこと）が交わる点のことです。2つあり、それぞれを春分点、秋分点とよんでいます。太陽が南から北に横切る点を春分点といいます。',
            5: '黄道と、天の赤道（地球の赤道をうちゅうまでえん長した線のこと）が交わる点のことです。2つあり、それぞれを春分点、秋分点と呼んでいます。太陽が南から北に横切る点を春分点といいます。',
            6: '黄道と、天の赤道（地球の赤道を宇宙まで延長した線のこと）が交わる点のことです。2つあり、それぞれを春分点、秋分点と呼んでいます。太陽が南から北に横切る点を春分点といいます。',
        }
    },
    {code: 204, category: 3,
        label: { default: '黄道', 1: 'こうどう', 2: '黄道', 3: '黄道', 4: '黄道', 5: '黄道', 6: '黄道'},
        phrase: {
            default: '太陽が地球の空の上を移動していく軌道をいいます。',
            1: 'たいようがちきゅうの空の上をいどうしていく きどうをいいます。',
            2: '太陽（たいよう）が地きゅうの空の上をいどうしていく き道をいいます。',
            3: '太陽が地球の空の上を移動（いどう）していく き道をいいます。',
            4: '太陽が地球の空の上を移動（いどう）していく き道をいいます。',
            5: '太陽が地球の空の上を移動していく き道をいいます。',
            6: '太陽が地球の空の上を移動していく き道をいいます。',
        }
    },
    {code: 205, category: 3,
        label: { default: '夏の大三角', 1: 'なつの大三かく', 2: '夏の大三角', 3: '夏の大三角', 4: '夏の大三角', 5: '夏の大三角', 6: '夏の大三角'},
        phrase: {
            default: '夏の東の空にみえ、こと座の「ベガ」、わし座の「アルタイル」、はくちょう座の「デネブ」の3つの星を結んでできる三角形です。',
            1: 'なつのひがしの空にみえ、ことざの「ベガ」、わしざの「アルタイル」、はくちょうざの「デネブ」の3つのほしをむすんでできる三かくけいです。',
            2: '夏の東の空にみえ、ことざの「ベガ」、わしざの「アルタイル」、はくちょうざの「デネブ」の3つの星をむすんでできる三角形です。',
            3: '夏の東の空にみえ、ことざの「ベガ」、わしざの「アルタイル」、はくちょうざの「デネブ」の3つの星をむすんでできる三角形です。',
            4: '夏の東の空にみえ、ことざの「ベガ」、わしざの「アルタイル」、はくちょうざの「デネブ」の3つの星を結んでできる三角形です。',
            5: '夏の東の空にみえ、ことざの「ベガ」、わしざの「アルタイル」、はくちょうざの「デネブ」の3つの星を結んでできる三角形です。',
            6: '夏の東の空にみえ、こと座の「ベガ」、わし座の「アルタイル」、はくちょう座の「デネブ」の3つの星を結んでできる三角形です。',
        }
    },
    {code: 206, category: 3,
        label: { default: '秋分点', 1: 'しゅうぶんてん', 2: '秋分点', 3: '秋分点', 4: '秋分点', 5: '秋分点', 6: '秋分点'},
        phrase: {
            default: '黄道と、天の赤道（地球の赤道を宇宙まで延長した線のこと）が交わる点のことです。2つあり、それぞれを春分点、秋分点と呼んでいます。太陽が北から南へ横切る点を秋分点といいます。',
            1: 'こうどうと、天のせきどう （ちきゅうのせきどうを うちゅうまでえんちょうしたせんのこと） がまじわるてんのことです。2つあり、それぞれをしゅんぶんてん、しゅうぶんてんとよんでいます。たいようがきたからみなみへよこぎるてんを しゅうぶんてんといいます。',
            2: '黄道と、天の赤道（地きゅうの赤道をうちゅうまでえん長した線のこと）が交わる点のことです。2つあり、それぞれを春分点、秋分点とよんでいます。太陽（たいよう）が北から南へよこ切る点を秋分点といいます。',
            3: '黄道と、天の赤道（地球の赤道をうちゅうまでえん長した線のこと）が交わる点のことです。2つあり、それぞれを春分点、秋分点とよんでいます。太陽が北から南へ横切る点を秋分点といいます。',
            4: '黄道と、天の赤道（地球の赤道をうちゅうまでえん長した線のこと）が交わる点のことです。2つあり、それぞれを春分点、秋分点とよんでいます。太陽が北から南へ横切る点を秋分点といいます。',
            5: '黄道と、天の赤道（地球の赤道をうちゅうまでえん長した線のこと）が交わる点のことです。2つあり、それぞれを春分点、秋分点とよんでいます。太陽が北から南へ横切る点を秋分点といいます。',
            6: '黄道と、天の赤道（地球の赤道を宇宙まで延長した線のこと）が交わる点のことです。2つあり、それぞれを春分点、秋分点と呼んでいます。太陽が北から南へ横切る点を秋分点といいます。',
        }
    },
    {code: 207, category: 3,
        label: { default: '天の川', 1: '天の川', 2: '天の川', 3: '天の川', 4: '天の川', 5: '天の川', 6: '天の川'},
        phrase: {
            default: '夜空を横切って見える光の帯を天空を流れる川に見立てて、天の川といわれています。これは雲のように見えますが、その正体は無数の星の集まりです。',
            1: 'よ空をよこぎって見える ひかりのおびを天空をながれる川に見立てて、天の川といわれています。これはくものように見えますが、その正たいはむすうのほしのあつまりです。',
            2: '夜空をよこ切って見える光のおびを天空をながれる川に見立てて、天の川といわれています。これは雲のように見えますが、その正体はむ数の星のあつまりです。',
            3: '夜空を横切って見える光のおびを天空を流れる川に見立てて、天の川といわれています。これは雲のように見えますが、その正体はむ数の星の集まりです。',
            4: '夜空を横切って見える光の帯を天空を流れる川に見立てて、天の川といわれています。これは雲のように見えますが、その正体は無数の星の集まりです。',
            5: '夜空を横切って見える光の帯を天空を流れる川に見立てて、天の川といわれています。これは雲のように見えますが、その正体は無数の星の集まりです。',
            6: '夜空を横切って見える光の帯を天空を流れる川に見立てて、天の川といわれています。これは雲のように見えますが、その正体は無数の星の集まりです。',
        }
    },
    {code: 301, category: 3,
        label: { default: 'プレセペ星団', 1: 'プレセペせいだん', 2: 'プレセペ星だん', 3: 'プレセペ星だん', 4: 'プレセペ星だん', 5: 'プレセペ星団', 6: 'プレセペ星団'},
        phrase: {
            default: 'プレセペ星団はかに座の散開星団（数十から数百個の恒星の集まり）です。プレセペはラテン語で「飼い葉桶」という意味で、プレセペ星団の両脇にある2つの星を飼い葉桶から餌を食べるロバに見立てて呼ばれました。',
            1: 'プレセペせいだんは かにざのさんかいせいだん（すう十からすう百このこうせいのあつまり）です。プレセペはラテンごで「飼い葉桶（かいはおけ）」といういみで、プレセペせいだんのりょうわきにある2つのほしを「飼い葉桶（かいはおけ）」からえさをたべるロバに見立ててよばれました。',
            2: 'プレセペ星だんはかにざのさんかい星だん（数十から数百このこう星のあつまり）です。プレセペはラテン語で「飼い葉桶（かいはおけ）」といういみで、プレセペ星だんのりょうわきにある2つの星を「飼い葉桶（かいはおけ）」からえさを食べるロバに見立ててよばれました。',
            3: 'プレセペ星だんはかにざのさん開星だん（数十から数百このこう星の集まり）です。プレセペはラテン語で「飼い葉桶（かいはおけ）」という意味で、プレセペ星だんの両わきにある2つの星を「飼い葉桶（かいはおけ）」からえさを食べるロバに見立ててよばれました。',
            4: 'プレセペ星だんはかにざの散開星だん（数十から数百このこう星の集まり）です。プレセペはラテン語で「飼い葉桶（かいはおけ）」という意味で、プレセペ星だんの両わきにある2つの星を飼い葉桶（かいはおけ）からえさを食べるロバに見立ててよばれました。',
            5: 'プレセペ星団はかにざの散開星団（数十から数百個のこう星の集まり）です。プレセペはラテン語で「飼い葉桶（かいはおけ）」という意味で、プレセペ星団の両わきにある2つの星を飼い葉桶（かいはおけ）からえさを食べるロバに見立ててよばれました。',
            6: 'プレセペ星団はかに座の散開星団（数十から数百個のこう星の集まり）です。プレセペはラテン語で「飼い葉桶（かいはおけ）」という意味で、プレセペ星団の両わきにある2つの星を飼い葉桶（かいはおけ）からえさを食べるロバに見立てて呼ばれました。',
        }
    },
    {code: 302, category: 3,
        label: { default: 'オリオン大星雲', 1: 'オリオン大せいうん', 2: 'オリオン大星雲', 3: 'オリオン大星雲', 4: 'オリオン大星雲', 5: 'オリオン大星雲', 6: 'オリオン大星雲'},
        phrase: {
            default: 'オリオン座にある大きくて明るい星雲です。この星雲は巨大なガスの集まりで、付近にある明るい星の光を受けて光っているため、ぼんやりした雲のように見えます。',
            1: 'オリオンざにある大きくてあかるいせいうんです。このせいうんはきょ大なガスのあつまりで、ふきんにあるあかるいほしのひかりをうけてひかっているため、ぼんやりしたくものように見えます。',
            2: 'オリオンざにある大きくて明るい星雲です。この星雲はきょ大なガスのあつまりで、ふ近にある明るい星の光をうけて光っているため、ぼんやりした雲のように見えます。',
            3: 'オリオンざにある大きくて明るい星雲です。この星雲はきょ大なガスの集まりで、ふ近にある明るい星の光を受けて光っているため、ぼんやりした雲のように見えます。',
            4: 'オリオンざにある大きくて明るい星雲です。この星雲はきょ大なガスの集まりで、付近にある明るい星の光を受けて光っているため、ぼんやりした雲のように見えます。',
            5: 'オリオンざにある大きくて明るい星雲です。この星雲はきょ大なガスの集まりで、付近にある明るい星の光を受けて光っているため、ぼんやりした雲のように見えます。',
            6: 'オリオン座にある大きくて明るい星雲です。この星雲はきょ大なガスの集まりで、付近にある明るい星の光を受けて光っているため、ぼんやりした雲のように見えます。',
        }
    },
    {code: 303, category: 3,
        label: { default: 'かに星雲', 1: 'かにせいうん', 2: 'かに星雲', 3: 'かに星雲', 4: 'かに星雲', 5: 'かに星雲', 6: 'かに星雲'},
        phrase: {
            default: 'かに星雲はおうし座にある超新星残骸（星が爆発した後に残る星雲状の天体）です。1054年に超新星爆発という大爆発が起き、かに星雲がうまれました。',
            1: 'かにせいうんは おうしざにある ちょうしんせいざんがい（ほしがばくはつしたあとにのこる せいうんじょうのてんたい）です。1054年にちょうしんせいばくはつというだ大ばくはつがおき、かにせいうんがうまれました。',
            2: 'かに星雲はおうしざにある ちょう新星ざんがい（星がばくはつした後にのこる星雲じょうの天体）です。1054年にちょう新星ばくはつという大ばくはつがおき、かに星雲がうまれました。',
            3: 'かに星雲はおうしざにある ちょう新星ざんがい（星がばく発した後にのこる星雲じょうの天体）です。1054年にちょうしん星ばく発という大ばく発が起き、かに星雲がうまれました。',
            4: 'かに星雲はおうしざにある ちょう新星残がい（星がばく発した後に残る星雲じょうの天体）です。1054年にちょう新星ばく発という大ばく発が起き、かに星雲がうまれました。',
            5: 'かに星雲はおうしざにある ちょう新星残がい（星がばく発した後に残る星雲状の天体）です。1054年にちょう新星ばく発という大ばく発が起き、かに星雲がうまれました。',
            6: 'かに星雲はおうし座にあるちょう新星残がい（星がばく発した後に残る星雲状の天体）です。1054年にちょう新星ばく発という大ばく発が起き、かに星雲がうまれました。',
        }
    },
    {code: 304, category: 3,
        label: { default: 'アンドロメダ銀河', 1: 'アンドロメダぎんが', 2: 'アンドロメダぎんが', 3: 'アンドロメダ銀が', 4: 'アンドロメダ銀が', 5: 'アンドロメダ銀河', 6: 'アンドロメダ銀河'},
        phrase: {
            default: 'アンドロメダ座にある渦状銀河です。およそ１兆個の星とガスからなる天体で、地球から230万光年の距離に位置しています。',
            1: 'アンドロメダざにある うずじょうぎんがです。およそ１ちょうこのほしとガスからなる天たいで、ちきゅうから230まんこう年のきょりにいちしています。',
            2: 'アンドロメダざにある うずじょうぎんがです。およそ１ちょうこの星とガスからなる天体で、地きゅうから230万光年のきょりにいちしています。',
            3: 'アンドロメダざにある うずじょう銀がです。およそ１ちょうこの星とガスからなる天体で、地球から230万光年のきょりにいちしています。',
            4: 'アンドロメダざにある うずじょう銀河（ぎんが）です。およそ１兆この星とガスからなる天体で、地球から230万光年のきょりに位置しています。',
            5: 'アンドロメダざにあるうず状銀河です。およそ１兆個の星とガスからなる天体で、地球から230万光年のきょりに位置しています。',
            6: 'アンドロメダ座にあるうず状銀河です。およそ１兆個の星とガスからなる天体で、地球から230万光年のきょりに位置しています。',
        }
    },
    {code: 305, category: 3,
        label: { default: 'かん状星雲', 1: 'かんじょうせいうん', 2: 'かんじょう星雲', 3: 'かんじょう星雲', 4: 'かんじょう星雲', 5: 'かん状星雲', 6: 'かん状星雲'},
        phrase: {
            default: '環状星雲はこと座にある惑星状星雲で、中心の星を取り巻くガスがリング状に光って見えます。「リング星雲」「ドーナツ星雲」とも言われます。',
            1: 'かんじょうせいうんは ことざにあるわくせいじょうせいうんで、ちゅうしんのほしをとりまくガスがリングじょうにひかって見えます。「リングせいうん」「ドーナツせいうん」ともいわれます。',
            2: 'かんじょう星雲はことざにあるわく星じょう星雲で、中心の星をとりまくガスがリングじょうに光って見えます。「リング星雲」「ドーナツ星雲」とも言われます。',
            3: 'かんじょう星雲はことざにあるわく星じょう星雲で、中心の星を取りまくガスがリングじょうに光って見えます。「リング星雲」「ドーナツ星雲」とも言われます。',
            4: 'かんじょう星雲はことざにあるわく星じょう星雲で、中心の星を取りまくガスがリングじょうに光って見えます。「リング星雲」「ドーナツ星雲」とも言われます。',
            5: 'かん状星雲はことざにあるわく星状星雲で、中心の星を取りまくガスがリング状に光って見えます。「リング星雲」「ドーナツ星雲」とも言われます。',
            6: 'かん状星雲はこと座にあるわく星状星雲で、中心の星を取り巻くガスがリング状に光って見えます。「リング星雲」「ドーナツ星雲」とも言われます。',
        }
    },
];
